export const locale = {
  general_menu_settings: 'إعدادات القائمة العامة',
  settings: {
  business_type_title: 'اختر نوع نشاط القائمة',
  currency_label: 'العملة',
  show_filter: 'عرض فلتر المنتجات',
  show_categories: 'عرض فئات المنتجات',
  
  business_types: {
    cafe: 'مقهى',
    restaurant: 'مطعم',
    fastfood: 'وجبات سريعة',
    icecream: 'عصير ومثلجات',
    sweets: 'حلويات',
    bakery: 'مخبز'
  },
  
  custom_labels: {
        ph_menu_cafe: 'قائمة المقهى',
    ph_menu_restaurant: 'قائمة الطعام',
    ph_menu_fastfood: 'قائمة الوجبات السريعة',
    ph_menu_icecream: 'العصير والآيس كريم',
    ph_menu_sweets: 'الكعك والحلويات',
    ph_menu_bakery: 'الخبز والمخبوزات',
    ph_product_list: 'المنتجات',
    ph_add_order: 'إضافة',
    ph_add_cart: 'شراء',

    title: 'تخصيص التسميات (اختياري)',
    subtitle: 'استبدل مصطلحات النظام الافتراضية بكلماتك المفضلة.',
    products_title: 'عنوان قسم المنتجات',
    ph_food_menu: 'قائمة الطعام',
    ph_product_list: 'قائمة المنتجات',
    cart_btn: 'نص زر الشراء',
    ph_add_order: 'أضف إلى الطلب',
    ph_add_cart: 'أضف إلى السلة'
  },

  currencies: {
    toman: 'تومان',
    rial: 'ريال'
  }
},
  check_account_balance_and_try_again: 'يرجى التحقق من رصيد الحساب والمحاولة مرة أخرى',
  problem_with_qr_renewal_request: 'حدثت مشكلة أثناء طلب تجديد رمز QR',

  ERRORS: {
    PhoneIsNotValid: "رقم الموبايل الدخلته مو صحيح: مثلاً 09101234567",
    InvalidNumber: "العدد الدخلته مو صحيح.",
    NoSelectedLineNumber: "فدوة اختار خط الإرسال.",
    EmptyText: "فدوة اكتب النص.",
    UnknownError: "خطأ ما معروف",
    TryAgain: "فدوة جرب مرة ثانية بعد شوية.",
    NoAccountCharge: "ماكو رصيد كافي",
    NoAccess: "ما عندك وصول.",
    PleasebyeAPlane: "فدوة اشتري باقة.",
    PleaseChargeYourAccount: "عفية عبي رصيد حسابك.",
    AccessDenied: "ممنوع الوصول.",
    AccessDeniedDescription: "خابر الدعم الفني حتى تعرف تفاصيل أكثر.",
    Error: "خطأ",
    InvalidText: "النص مو صحيح",
    InvalidTextContainsLink: "بس الخطوط الخدمية تكدر تخلي بيها روابط.",
    NoPhoneToSend: "ماكو أرقام حتى تدز إلها.",
  },
  FORMS: {
    SuccsessFullySended: "افتهمت",
    DestinationPhone: "رقم المستلم",
    TestDestinationPhone: "رقم موبايل التجربة",
    SourceNumber: "رقم المرسل",
    Text: "النص",
    CharCount: "عدد الأحرف",
    FarsiCharCount: "عدد الأحرف الفارسية",
    EnglishCharCount: "عدد الأحرف الإنجليزية",
    Send: "دز",
    SendTime: "وقت الإرسال",
    SendTest: "دز تجربة",
    SendToTestNumber: "دز لرقم التجربة",
    SmsCount: "عدد الرسائل",
    SmsLang: "لغة الرسالة",
    Add: "ضيف",
    FromFile: "ضيف من ملف",
    TestNumber: "رقم التجربة",
    Test: "تجربة",
    ServiceRelated: "خدمي",
    Price: "كلفة إرسال القائمة البيضة",
    TotalPrice: "الكلفة الكلية",
    NumbersCount: "كل الأرقام",
    BlacklistPrice: "كلفة إرسال القائمة السودة",
    BlacklistNumbersCount: "عدد القائمة السودة",
    WhitelistNumbersCount: "عدد القائمة البيضة",
    IrancellNumbersBlacklistCount: "عدد القائمة السودة لإيرانسل",
    HamrahavalNumbersBlacklistCount: "عدد القائمة السودة لهمراه أول",
    IrancellNumbersWhitelistCount: "عدد القائمة البيضة لإيرانسل",
    HamrahavalNumbersWhitelistCount: "عدد القائمة البيضة لهمراه أول",
    NumbersCountToSend: "عدد الأرقام الزينة",
    Search: "دور",
    Title: "العنوان",
    RequestTime: "وقت الطلب",
    RequestInformation: "معلومات الطلب",
    CreateNewPhoneBook: "سوي سجل أسماء جديد",
    AddPhone: "ضيف أرقام",
    Remove: "امسح",
  },
  unexpected_error: "صار خطأ غير متوقع. حاول مرة ثانية.",
  luck_wheel_name: "اسم الكيو آر مال عجلة الحظ",
  update_video: "إضافة معرض فيديوهات",
  edit: "تعديل",
  to_top: "من فوق",
  to_bottom: "من جوه",
  to_left: "من اليمين لليسار",
  to_right: "من اليسار لليمين",
  to_top_right: "من جوه لليمين",
  to_top_left: "من جوه لليسار",
  to_bottom_right: "من فوق لليمين",
  to_bottom_left: "من فوق لليسار",
  select_color_gradient: "اختيار لون الگريديانت",
  select_color_solid: "اختيار لون سادة",
  gradient_direction: "اتجاه الگريديانت",
  gradient_background: "خلفية الگريديانت",
  qr_downloaded_successfully: "الـQR نزّل بنجاح.",
  logo: "لوگو",
  qr_design_size: "تصميم وحجم الـQR",
  qr_eye_design: "تصميم عين الـQR",
  qr_markout: "هامش الخرج",
  frame: "فريم",
  ready_card_samples: "نماذج كارتات جاهزة",
  ready_card_sample: "نموذج كارت جاهز",
  remove_default_info: "حذف المعلومات الافتراضية",
  select_ready_card: "اختيار كارت جاهز",
  connection_code: "كود الاتصال",
  enter_visit_card_info: "دخل معلومات الكارت",
  info: "معلومات",
  select_template_design: "اختيار تصميم القالب",
  qr_address: "عنوان الـQR",
  visit_card_name: "اسم الكارت الخاص بيك",
  visit_card_name_pro: "اسم الكارت الخاص برو بيك",
  download_qr: "تنزيل الـQR",
  fast_design: "تصميم سريع",
  professional_design: "تصميم احترافي",
  ai_design: "تصميم ذكاء اصطناعي",
  update_qr: "تحديث الـQR",
  fast_design_message:
    "انتقلت لتصميم الكود السريع. التصميم السابق سويته بهذا القسم.",
  professional_design_message:
    "انتقلت لتصميم الكود الاحترافي. التصميم السابق سويته بهذا القسم.",
  scan_me: "اسكنني",
  visit_card_edited_successfully: "كارتك اتعدّل بنجاح.",
  customer_club_membership: "عضوية نادي الزبائن",
  qrland: "كيو آر لاند",
  dynamic: "داينامك",
  about_us_text:
    "مميزات كيو آر كود داينامك:\n✔️ تعديل غير محدود\n✔️ مسح سهل\n✔️ إمكانية تحديد عدد المسح\n✔️ إمكانية إضافة باسوورد\n✔️ عرض ومراجعة إحصائيات الزوار\n✔️ تغيير لون مظهر الكيو آر\n✔️ حفظ المعلومات والأمان\n✔️ إمكانية إضافة صورة ولوگو للكيو آر\n✔️ إمكانية إضافة كيو آر متخصص حسب حاجة العمل\n✔️ نقل الماسح للروابط والموقع\n✔️ تقديم كيو آر ورابط مختصر سوية\n✔️ ينفع بكل الشبكات الاجتماعية (أوفلاين وأونلاين)\n✔️ ينفع تنزيله بأي صيغة تبي\n✔️ ينفع طباعته على أي سطح أو حجم",
  video_gallery: "معرض الفيديو",
  address_text: "بغداد، شارع فلسطين، بعد جسر الصرافية، زقاق الخالدية، لوحة 6",
  visit_card: "كارت زيارة",
  qrland_system: "نظام كيو آر لاند",
  qrland_first_system: "أول نظام يسوي كيو آر كود داينامك",
  address: "عنوان",
  enter_site_link: "دخل رابط الموقع اللي تبيه",
  instagram: "إنستا",
  enter_instagram_username: "دخل يوزرك",
  whatsapp: "واتساب",
  invalid_qr_address: "العنوان اللي دخلته مو صح!",
  visit_card_created_successfully: "كارتك اتخلّق بنجاح.",
  qr_creation_failed: "صار خطأ بصنع الـQR!",
  manage_password: "إدارة الباسوورد",
  hour_limit: "حد الوقت",
  scan_click_limit: "حد عدد المسح/النقر",
  redirect_scanner: "تحويل الماسح",
  edit_settings_error: "صار خطأ بتعديل الإعدادات!",
  next: "التالي",
  add: "إضافة",
  header_color_settings: "إعدادات لون ونص الراس",
  select_image: "اختيار صورة",
  enter_qr_address: "دخل عنوان الـQR الخاص بيك",
  qr_idea_title: "فكرة صنع كيو آر",
  qr_idea: "فكرة كيو آر",
  qr_idea_subject: "موضوع صنع كيو آر",
  confirm_qr_idea: "تأكيد فكرتي للكيو آر",
  scannable: "ينمسح",
  ai_sample: "نموذج من صنع الذكاء الاصطناعي...",
  scan_warning: "يمكن ما ينمسح على كل الأجهزة. إذا ما مشى، جرب مرة ثانية.",
  ai_description: "دخل وصف الـQR اللي تبيه، الذكاء الاصطناعي يخلّقه لك.",
  attach: "إرفاق",
  remaining: "الباقي",
  qr_creation: "صنع كيو آر",
  free: "مجاني",
  select_language_for_request: "اختيار اللغة لكتابة نص الطلب",
  request_text: "نص الطلب",
  request_text_placeholder: "وصف الـQR اللي تبيه...",
  strengthen_text: "تقوية النص الحالي",
  prompt_idea: "فكرة البرمبت",
  try_again: "جرب مرة ثانية",
  create_qr: "اصنع كيو آر",
  smart_qr_code: "كيو آر ذكي",
  regenerate_image: "إعادة صنع الصورة",
  updating_qr: "جاري تحديث الـQR...",
  copied: "اتنسخ",
  copy: "نسخ",
  print_qr: "طباعة كيو آر",
  print_visit_card: "طباعة الكارت",
  send_link: "إرسال الرابط",
  customer_list: "قائمة الزبائن",
  order_list: "قائمة الطلبات",
  reserved_appointments: "المواعيد المحجوزة",
  feedback: "ملاحظات",
  request_form: "نموذج الطلب",
  transfer_ownership: "نقل الملكية",
  select_nfc_card: "اختيار كارت NFC",
  created_at: "اتخلّق",
  last_edit: "آخر تعديل",
  qr_card: "كارت كيو آر",
  viewed: "شافوه",
  see_more: "شوف أكثر",
  download: "تنزيل",
  activate: "تفعيل",
  design: "تصميم",
  qr_settings: "إعدادات الـQR",
  deactivate: "إيقاف",
  qr_color_size: "لون وحجم الـQR",
  dots_design_color: "تصميم ولون النقاط",
  eye_design_color: "تصميم ولون العين",
  border_design_color: "تصميم ولون الحدود",
  logo_settings: "إعدادات اللوگو",
  download_qr_comment: "تنزيل الـQR",
  connection_established: "الاتصال صار.",
  show_qr: "عرض الـQR",
  preview: "معاينة",
  user_info: "معلومات المستخدم",
  sms_club_membership: "عضوية نادي الرسائل",
  smart_settings: "إعدادات ذكية",
  add_audio_file: "إضافة ملف صوتي",
  back: "رجوع",
  after_click_location: "بعد ما تضغط على الموقع، اختار تطبيق الخريطة.",
  phone_number: "رقم الهاتف",
  auto_display: "عرض تلقائي",
  customer_club: "نادي الزبائن",
  auto_download: "تنزيل تلقائي",
  save: "حفظ",
  about_us: "عنّا",
  view_more: "شوف أكثر",
  view_less: "شوف أقل",
  audio_file: "ملف صوتي",
  add_video: "إضافة فيديو",
  add_image: "إضافة صورة",
  select_color: "اختيار اللون",
  header_color: "نص الراس",
  add_social_networks: "إضافة الشبكات الاجتماعية",
  format: "صيغة",
  output_size: "حجم الخرج",
  file_type: "نوع الملف",
  default: "افتراضي",
  qr_download_error: "صار مشكلة بتنزيل الـQR. جرب مرة ثانية",
  header_color_text_settings: "إعدادات لون ونص الراس",
  upload_catalog_images: "رفع صور الكتالوج / البروشور",
  delete: "حذف",
  personal_domain: "دومين شخصي",
  no_domain_found: "ما لكينا دومين!",
  enter_domain_address: "دخل عنوان الدومين الخاص بيك",
  dns_setup_note: "تذكر لازم تسوي إعدادات DNS السيرفر أول شي!",
  attention: "تنبيه: ",
  dns_setup_instruction: "للتسجيل بالدومين الشخصي، لازم تسوي DNS",
  and: "و",
  setup_on_domain: "على الدومين الخاص بيك.",
  dns_change_time: "(وقت تغيير DNS يوصل لـ24 ساعة)",
  add_domain: "إضافة دومين",
  add_personal_domain: "إضافة دومين شخصي",
  min_characters: "أقل عدد حروف",
  domain_format:
    "الدومين لازم يكون شكله https://terminalads.com أو terminalads.com",
  invalid_domain: "الدومين اللي دخلته مو صح!",
  domain_added_successfully: "الدومين اتضاف بنجاح",
  invalid_dns_settings: "إعدادات DNS مو صحيحة!",
  deleted_successfully: "اتحذف بنجاح",
  location: "موقع",
  save_contact: "حفظ جهة الاتصال",
  search: "دور",
  data_fetch_error: "خطأ بجلب البيانات!",
  error: "خطأ",
  view_qr: "شوف الـQR",
  qr_design: "تصميم الـQR",
  register: "تسجيل",
  terminal_ads: "ترمينال إعلانات",
  manage_40_advertising_methods: "إدارة 40 طريقة إعلانية مع بعض!",
  ms_khansari: "الست خوانساري",
  support: "دعم",
  comprehensive_advertising_system:
    "النظام الوحيد الشامل لفحص وإدارة الإعلانات أونلاين",
  terminal_ads_description:
    "نظام ترمينال إعلانات يفخر بتواصله المستمر مع الزبائن والجمهور عشان يفهم احتياجاتهم ويقدم أحسن الحلول. أكبر رأس مال عندنا هم الزبائن والمستخدمين المخلصين، وبعدهم فريق المتخصصين اللي يساعدونا بأفكار جديدة وتقنيات حديثة.",
  please_enter_qr_address_correctly: "دخل عنوان الـQR صح!",
  server_error: "خطأ بالسيرفر!",
  please_enter_your_address: "دخل عنوانك",
  please_enter_instagram_address: "دخل عنوان إنستاك",
  please_enter_whatsapp_address: "دخل عنوان واتسابك",
  enter_information: "دخل المعلومات",
  dynamic_qr: "كيو آر داينامك",
  coming_soon: "قريباً",
  qr_name: "اسم الـQR",
  for_default_address_leave_empty: "!للعنوان الافتراضي، خلّيه فاضي",
  default_address: "العنوان الافتراضي",
  sms: "رسالة",
  enter_number_without_zero: "دخل الرقم بدون 0.",
  number: "رقم ",
  country_code: "رمز الدولة:",
  sms_text: "نص الرسالة",
  complete_sms_fields_correctly: "لازم تملأ حقول الرسائل النصية صح!",
  qr_code_created_successfully: "كود الكيو آر تبعك اتخلق بنجاح.",
  chat: "دردشة",
  call: "اتصال",
  please_enter_username: "دخل اسم المستخدم تبعك لو سمحت.",
  username: "اسم المستخدم",
  sample_menu: "قائمة عينة",
  online_menu_name: "اسم قائمتك أونلاين",
  online_menu_name_short: "اسم القائمة أونلاين",
  enter_menu_information: "دخل معلومات القائمة",
  select_sample_menu: "اختر قائمة عينة",
  select_ready_menu: "اختر قائمة جاهزة",
  online_sales: "بيع أونلاين",
  sales_settings: "إعدادات البيع",
  photo_gallery: "معرض صور",
  fast_food1: "فاست فود 1",
  fast_food2: "فاست فود 2",
  products: "المنتجات",
  pizzas: "البيتزات",
  pizza_rust_beef: "بيتزا روست بيف",
  italian_pizza_with_beef: "🤩 بيتزا إيطالية بلحم بقر",
  italian_pizza_dough_30cm: "عجينة بيتزا إيطالية 30 سم",
  "100g_shredded_beef": "100 غرام لحم بقر مفروم",
  mushroom_bell_pepper: "فطر، فلفل رومي",
  black_olives: "زيتون أسود",
  pizza_chicken_mushroom: "بيتزا دجاج وفطر",
  classic_40cm: "🍕 كلاسيك 40 سم",
  fresh_tomato_sauce: "صلصة طماطس طازجة، جبن، فيليه دجاج، فطر، زعتر جبلي",
  pizza_meat_mushroom: "بيتزا لحم وفطر",
  meat_pizza_with_mushroom: "🥰 بيتزا لحم مفروم وفطر",
  pizza_vegetables: "بيتزا خضار",
  american_vegetable_pizza: "🍕 بيتزا خضار أمريكية",
  american_pizza_dough:
    "عجينة بيتزا أمريكية، ذرة، فطر، زيتون، طماطس، بصل، فلفل، جبن",
  special_pizza: "بيتزا خاصة",
  american_special_pizza: "بيتزا خاصة أمريكية",
  pizza_bolognese: "بيتزا بولونيز",
  one_person_23cm: "(شخص واحد) عجينة بيتزا 23 سم 🤌",
  pepperoni_pizza: "بيتزا بيبروني",
  one_person_23cm_dough: "(شخص واحد) عجينة بيتزا 23 سم",
  bacon_pizza: "بيتزا بيكون",
  one_person_23cm_explosion: "(شخص واحد) عجينة بيتزا 23 سم 💥",
  mixed_pizza: "بيتزا مشكلة",
  one_person_23cm_mixed: "(شخص واحد) عجينة بيتزا 23 سم 🤭",
  american_steak_pizza: "بيتزا ستيك أمريكية",
  one_person_23cm_steak: "(شخص واحد) 23 سم 💥",
  burgers: "البرغر",
  cheese_burger: "تشيز برغر",
  with_french_fries: "🤩 وياه بطاطس مقلية",
  "2_beef_burgers_150g": "قطعتين برغر لحم 150 غرام",
  special_sauce_gouda_cheese: "صلصة خاصة، جبن غودا",
  pickles_lettuce_tomato: "مخلل، خس، طماطس",
  special_sauce: "صلصة خاصة",
  burger: "برغر",
  pure_meat_with_special_sauce: "😍 لحم صافي وياه صلصة خاصة",
  chicken_burger: "تشيكن برغر",
  grilled_chicken_burger_with_cheese: "برغر دجاج مشوي وجبن",
  spicy_burger: "برغر حار",
  beef_with_spicy_sauce: "لحم بقر وصلصة حارة",
  double_burger: "دبل برغر",
  "150g_beef": "لحم بقر 150 غرام",
  royal_burger: "رويال برغر",
  "150g_beef_emoji": "150 غرام لحم بقر 🍔",
  mushroom_burger: "برغر فطر",
  "150g_beef_mushroom": "لحم بقر 150 غرام",
  mushroom_burger_grilled: "ماشروم برغر",
  "100_percent_grilled_beef": "لحم بقر مشوي 100% 🤩",
  fried_burger: "برغر مقلي",
  "100_percent_grilled_fried": "لحم بقر مشوي ومقلي 100% 👌",
  fried: "مقلي",
  fried_chicken: "دجاج مقلي",
  "3_piece_fried_chicken": "😍 دجاج مقلي ثلاث قطع",
  "3_fried_chicken_pieces": "3 قطع دجاج مقلي",
  "120_150g_french_fries": "120-150 غرام بطاطس مقلية",
  enter_product_information: "دخل معلومات المنتج",
  product_name: "اسم منتجك",
  product_name_short: "اسم المنتج",
  complete_features_from_image: "كمل الميزات من صورة المنتج",
  skip_step: "تخطى الخطوة",
  product_and_information: "المنتج والمعلومات",
  product_introduction: "تعريف المنتج",
  shiva_waves: "شيفا أمواج",
  think_best: "فكر بالأحسن...",
  iran_zanjan_abhar:
    "إيران، زنجان، أبهر، منطقة صناعية شريف، جنب محطة كهرباء 63/20",
  video_gallery_description: "شوف فيديوهاتنا.",
  gallery: "المعرض",
  welcome: "أهلاً وسهلاً",
  invalid_address: "العنوان اللي دخلته مو صحيح!",
  product_created_successfully: "منتجك اتخلق بنجاح.",
  qr_visit_card_edited_successfully: "بطاقة الزيارة تبعك اتعدلت بنجاح.",
  change_header_color: "غير لون الرأس",
  change_body_color: "غير لون الجسم",
  change_button_colors: "غير ألوان الأزرار",
  change_text_colors: "غير ألوان النصوص",
  gradient_colors: "ألوان تدرج",
  color_direction: "اتجاه اللون",
  first_color: "اللون الأول",
  second_color: "اللون الثاني",
  color: "اللون",
  text_color: "لون النص",
  from_top: "من فوق",
  from_bottom: "من تحت",
  from_left_to_right: "من اليسار لليمين",
  from_right_to_left: "من اليمين لليسار",
  from_top_to_left: "من فوق لليسار",
  from_top_to_right: "من فوق لليمين",
  from_bottom_to_left: "من تحت لليسار",
  from_bottom_to_right: "من تحت لليمين",
  sharing: "مشاركة",
  business_shop: "بيزنس / دكان",
  corporate_organizational: "شركة / تنظيمي",
  customer_contact: "تواصل ويا الزبون",
  information: "معلومات",
  miscellaneous: "متنوع",
  link: "لينك",
  margin: "هامش",
  width: "العرض",
  height: "الارتفاع",
  background_color: "لون الخلفية",
  gradient_color: "لون التدرج",
  linear: "خطي",
  radial: "دائري",
  color_rotation: "دوران اللون",
  background_color_label: "لون الخلفية",
  dots_color: "لون النقاط",
  dots_color_label: "لون النقاط",
  eye_colors: "ألوان العين",
  separate_colors_for_each_eye: "ألوان منفصلة لكل عين",
  current_mode: "الوضع الحالي:",
  separate_colors: "ألوان منفصلة",
  same_color: "لون واحد",
  all_eyes_color: "لون كل العيون",
  top_right_eye: "العين فوق يمين",
  top_left_eye: "العين فوق يسار",
  bottom_left_eye: "العين تحت يسار",
  upload_logo: "ارفع اللوغو",
  hide_background_dots: "اخفِ النقاط ورا اللوغو",
  logo_size: "حجم اللوغو",
  logo_margin: "هامش اللوغو",
  qr_accuracy: "دقة الكيو آر",
  mode: "الوضع",
  error_correction_level: "مستوى تصحيح الخطأ",
  numeric: "رقمي",
  alphanumeric: "حروف ورقم",
  byte: "بايت",
  apply_changes: "طبق التغييرات",
  please_click_apply_changes: 'اضغط "طبق التغييرات" بعد ما تختار التعديلات.',
  created_qr_codes: "كيو آر اتخلقت",
  square_ratio: "1:1 (مربع)",
  image_upload_error: "خطأ برفع الصورة!",
  visit_card_name_label: "اسم بطاقة الزيارة",
  sms_membership_message: "رسالة عضوية نادي الزبائن برسالة نصية",
  admin_menu: "قائمة الأدمن",
  user_menu: "قائمة المستخدم العادي",
  guide_tooltip: "دليل",
  close: "سد",
  browser_video_support_error: "متصفحك ما يدعم أي صيغة فيديو.",
  video_loading_error: "خطأ بتحميل الفيديو (يمكن الوصول محدود).",
  click_more_for_videos: "اضغط المزيد عشان تشوف فيديوهات أكثر.",
  more_info: "معلومات أكثر",
  more: "المزيد",
  add_user_guide: "أضف دليل المستخدمين",
  edit_user_guide: "عدل دليل المستخدمين",
  display_info: "اعرض المعلومات",
  element: "العنصر",
  disable_attach: "عطل الإرفاق عشان يتناسب ويا الصفحة",
  view: "شوف",
  guide: "دليل",
  details: "التفاصيل",
  guide_images: "صور الدليل",
  guide_videos: "فيديوهات الدليل",
  faq: "أسئلة شائعة",
  data_preload_error: "خطأ بتحميل البيانات المسبق:",
  guide_not_found: "ما لكينا دليل. خلق دليل أول.",
  delete_guide_question: "تحذف الدليل؟",
  delete_guide_error: "خطأ بحذف الدليل!",
  unknown_file_type: "نوع الملف ما معروف:",
  content_type_error: "خطأ باستلام نوع المحتوى:",
  video: "فيديو",
  image: "صورة",
  guide_data_error: "خطأ باستلام بيانات الدليل:",
  add_iranian_stores: "أضف متاجر إيرانية",
  add_foreign_stores: "أضف متاجر أجنبية",
  bazaar: "بازار",
  myket: "مايكت",
  app_store: "آب ستور",
  google_play: "غوغل بلاي",
  samsung_store: "متجر سامسونغ",
  xiaomi_store: "متجر شاومي",
  vivo_store: "متجر فيفو",
  amazon_store: "متجر أمازون",
  bazaar_app: "تطبيق بازار",
  bazaar_link_placeholder: "دخل لينك التطبيق ببازار",
  bazaar_link_hint:
    "دخل لينك بازار صالح (مثال: https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "تطبيق مايكت",
  myket_link_placeholder: "دخل لينك التطبيق بمايكت",
  myket_link_hint: "دخل لينك مايكت صالح (مثال: myket://details?id=com.example)",
  app_store_app: "تطبيق آب ستور",
  app_store_link_placeholder: "دخل لينك التطبيق بآب ستور",
  app_store_link_hint:
    "دخل لينك آب ستور صالح (مثال: https://apps.apple.com/us/app/appname/id123456789)",
  google_play_app: "تطبيق غوغل بلاي",
  google_play_link_placeholder: "دخل لينك التطبيق بغوغل بلاي",
  google_play_link_hint:
    "دخل لينك غوغل بلاي صالح (مثال: https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "تطبيق متجر سامسونغ",
  samsung_store_link_placeholder: "دخل لينك التطبيق بمتجر سامسونغ",
  samsung_store_link_hint:
    "دخل لينك متجر سامسونغ صالح (مثال: https://galaxy.store/appname)",
  xiaomi_store_app: "تطبيق متجر شاومي",
  xiaomi_store_link_placeholder: "دخل لينك التطبيق بمتجر شاومي",
  xiaomi_store_link_hint: "دخل لينك متجر شاومي صالح",
  vivo_app_store: "متجر تطبيقات فيفو",
  vivo_app_store_app: "تطبيق متجر تطبيقات فيفو",
  vivo_app_store_link_placeholder: "دخل لينك التطبيق بمتجر تطبيقات فيفو",
  vivo_app_store_link_hint: "دخل لينك متجر تطبيقات فيفو صالح",
  amazon_store_app: "تطبيق متجر أمازون",
  amazon_store_link_placeholder: "دخل لينك التطبيق بمتجر أمازون",
  amazon_store_link_hint: "دخل لينك متجر أمازون صالح",
  iranian_store: "متجر إيراني",
  foreign_store: "متجر أجنبي",
  personal_store: "متجر شخصي",
  image_logo: "صورة/لوغو",
  image_gallery: "معرض صور",
  header_image: "صورة الرأس",
  template_background_image: "صورة خلفية القالب",
  background_image: "صورة الخلفية",
  background_image_alt: "صورة الخلفية",
  logo_upload: "ارفع اللوغو",
  welcome_image: "صورة الترحيب",
  welcome_image_logo_upload: "ارفع صورة/لوغو الترحيب",
  loading_animation: "تحريك التحميل",
  preview_welcome_page: "شوف معاينة صفحة الترحيب",
  max_background_size: "أكبر حجم لكل صورة خلفية 2 ميغا.",
  max_logo_size: "أكبر حجم لكل لوغو 2 ميغا.",
  scale_from_center: "كبر من الوسط",
  slide_from_left: "دخل من اليسار",
  slide_from_top: "دخل من فوق",
  fade: "يختفي",
  select_music_card: "اختر بطاقة موسيقى",
  show_audio: "اعرض الصوت",
  hide_audio: "اخفِ الصوت",
  add_voice: "أضف صوت",
  max_files_limit: "ما تقدر تختار أكثر من {count} ملف!",
  files_not_allowed: "الملفات ممنوعة!",
  voice_gallery: "معرض صوت",
  edit_voice: "عدل الصوت",
  list: "القائمة",
  file_name: "اسم الملف",
  title: "العنوان",
  description: "الوصف",
  selectdate: "اختر التاريخ",
  background: "الخلفية",
  text: "النص",
  delete_audio_confirm: "متأكد تحذف الملف الصوتي من معرضك؟",
  add_voice_gallery: "أضف معرض صوتي",
  gallery_number: "المعرض",
  delete_confirm: "متأكد تحذف",
  confirm: "؟",
  voice_gallery_title_hint: "دخل عنوان معرضك الصوتي.",
  voice_gallery_title: "العنوان",
  voice_gallery_subtitle_hint: "دخل العنوان الفرعي لمعرضك الصوتي.",
  voice_gallery_subtitle: "العنوان الفرعي للمعرض الصوتي",
  voice_gallery_subtitle_alt: "العنوان الفرعي",
  website_address_hint: "دخل عنوان موقعك الإلكتروني.",
  website_address: "عنوان الموقع الإلكتروني",
  about_voice_gallery: "عن المعرض",
  about_voice_gallery_alt: "عن المعرض",
  button_name_hint: "دخل اسم الزر.",
  button_name: "اسم الزر",
  domain_format_hint:
    "الدومين لازم يكون https://terminalads.com أو terminalads.com.",
  about_us_alt: "عنا",
  add_default_form: "أضف نموذج افتراضي",
  delete_all: "احذف الكل",
  validation_active: "التحقق: مفعل",
  validation_inactive: "التحقق: معطل",
  validation: "التحقق",
  clear_form: "امسح النموذج",
  status: "الحالة",
  active: "مفعل",
  inactive: "معطل",
  optional: "اختياري",
  required: "إلزامي",
  question_title: "العنوان",
  question_title_hint: "دخل عنوان السؤال",
  options_hint: "اكتب الخيارات وبعدين اضغط إنتر عشان تضيف",
  options: "الخيارات",
  add_suggested_form: "أضف نموذج طلب مقترح",
  save_changes: "احفظ التغييرات",
  add_request_field: "أضف حقل طلب",
  select_form_type: "اختر نوع النموذج",
  select_form_type_placeholder: "اختر نوع النموذج",
  dropdown: "قائمة منسدلة",
  text_field: "حقل نص",
  number_field: "حقل رقم",
  textarea_field: "حقل نص مفتوح",
  date_field: "حقل تاريخ",
  field_name_required: "اسم الحقل ما يقدر يكون فاضي",
  field_name: "اسم الحقل",
  add_field_name: "أضف اسم الحقل",
  field_label: "نص الليبل",
  add_field_label: "أضف ليبل الحقل",
  advanced_settings: "إعدادات متقدمة",
  select_input_pattern: "اختر نمط الإدخال",
  select_input_pattern_placeholder: "اختر نمط الإدخال",
  max_characters: "أكبر عدد حروف",
  min_input_error: "أقل إدخال لازم يكون 0",
  name_field: "الاسم",
  field_type: "نوع الحقل",
  persian_limit: "قيد اللغة الفارسية",
  family_name: "اسم العائلة",
  mobile_number: "رقم الجوال",
  number_limit: "قيد الرقم",
  national_code: "الرمز الوطني",
  meli_code: "الرمز الوطني",
  email: "الإيميل",
  email_limit: "قيد الإيميل",
  dropdown_field: "قائمة منسدلة",
  english_limit: "قيد اللغة الإنجليزية",
  mix_per_eng_limit: "قيد الفارسية والإنجليزية",
  site_limit: "قيد الموقع",
  form_added_successfully: "النموذج الجديد اتضاف بنجاح",
  form_updated_successfully: "النموذج اتحدث بنجاح",
  delete_item_confirm: "متأكد تحذف العنصر؟",
  default_form_added_successfully: "النموذج الافتراضي اتضاف بنجاح",
  resources_upload_error: "صار خطأ برفع الموارد",
  update_value_if_duplicate: "حدث القيمة إذا مكررة",
  first_tab: "التب الأول",
  display_count: "عدد العرض",
  buy_renew_qr_instruction: "عشان تشتري/تجدد الكيو آر، اضغط زر مدة الانتهاء.",
  days_until_expiry: "أيام للانتهاء",
  expired: "منتهي",
  no_qr_to_display: "ماكو كيو آر يعرض!",
  second_tab: "التب الثاني",
  total_qr_codes: "مجموع كيو آر",
  select_all: "اختر الكل",
  selected_qr_codes_count: "عدد الكيو آر المختارة",
  qr_codes_count: "عدد الكيو آر",
  group_renewal_instruction: "لتجديد جماعي، اختر الكيو آر اللي تبيه.",
  no_qr_found_with_filters: "ما لكينا كيو آر بهالفلاتر!",
  qr_codes_count_label: "عدد الكيو آر:",
  renew_qr: "جدد الكيو آر",
  days: "أيام",
  buy_now: "اشتري الحين!",
  buy_now_label: "اشتري",
  add_discount_code: "أضف كود خصم",
  use_discount_code: "استخدم كود الخصم",
  discount_code: "كود الخصم",
  submit: "ارسل",
  my_qr_list: "قائمة كيو آري",
  group_renewal: "تجديد جماعي",
  row: "الصف",
  type: "النوع",
  clicks: "الزيارات",
  created_at_diff: "وقت الخلق",
  updated_at_diff: "وقت التحديث",
  table_view: "عرض جدول",
  normal_view: "عرض عادي",
  no_qr_or_id_selected: "ما مختار أي كيو آر أو آي دي!",
  qr_updated_successfully: "الكيو آر اتحدث بنجاح.",
  qr_update_error: "خطأ بتحديث الكيو آر!",
  no_qr_selected: "ما مختار أي كيو آر!",
  no_qr_code_selected: "ما مختار أي كود كيو آر!",
  success: "نجاح",
  qrs_upgraded_successfully: "كيو آرك اتطورت بنجاح.",
  qr_renewal_error: "صار مشكلة بطلب تجديد الكيو آر!",
  changed_successfully: "اتغير بنجاح.",
  error_occurred: "صار خطأ!",
  no_tariff_exists: "ماكو تعرفة!",
  qr_upgraded_successfully: "كيو آرك اتطور بنجاح.",
  check_account_balance: "شوف رصيد حسابك وحاول بعدين.",
  group_renewal_price_error: "خطأ باستلام سعر التجديد الجماعي!",
  qr_count_error: "خطأ باستلام عدد الكيو آر!",
  no_qr_for_renewal: "ماكو كيو آر للتجديد!",
  table_pagination: "ترقيم فوق الجدول",
  virtual_scroll_display: "عرض البيانات بتمرير افتراضي",
  popups_shared_components: "نوافذ منبثقة ومكونات مشتركة",
  edit_qr_address: "عدل عنوان الكيو آر",
  please_enter_correct_address: "دخل عنوان صح",
  successfully_edited: "اتعدل بنجاح.",
  error_editing_qr_address: "خطأ بتعديل عنوان الكيو آر!",
  go_to_page: "روح للصفحة",
  page_from_to: "صفحة {current} من {last}",
  display: "عرض",
  to: "لـ",
  from: "من",
  show: "اعرض",
  page_status: "صفحة {current} من {total}",
  until: "لحد",
  successfully_completed: "اتكمل بنجاح",
  problem_occurred: "صارت مشكلة",
  download_failed: "التحميل فشل",
  audio_file_default: "ملف صوتي",
  memory_release: "تحرير الذاكرة",
  seek_music_comment: "مثلاً هالموسيقى أو أي شي يبحث عنه",
  all: "الكل",
  create_podcast: "خلق بودكاست",
  add_link: "أضف لينك",
  upload_file: "ارفع ملف",
  file_list: "قائمة الملفات",
  count: "العدد",
  select_category: "اختر الفئة",
  after_typing_enter: "بعد الكتابة، اضغط إنتر.",
  no_image_available: "ماكو صورة",
  no_image_found: "ما لكينا صورة!",
  for_adding_file_use_upload_center:
    "عشان تضيف ملف، استخدم حقل رفع الصور أو مركز الرفع",
  ai_story_creation_description: "دخل قصتك، والذكاء الاصطناعي يخلقها لك",
  create_new_podcast: "خلق بودكاست جديد",
  show_audio_file: "اعرض ملف الصوت",
  cancel: "إلغاء",
  no_audio_in_category: "ماكو ملفات صوت بهالفئة",
  health_apple: "تفاحة الصحة",
  standard: "معيار",
  arshia_badge: "شارة أرشيا",
  home_appliances_association: "جمعية الأجهزة المنزلية",
  energy_label: "تسمية الطاقة",
  select_gold_purity_first: "عشان تحصل السعر، حدد عيار الذهب أول",
  gold_price_service: "خدمة استلام سعر الذهب",
  rahvard: "راهورد",
  to_change_gold_service_go_to_assets:
    "عشان تغير خدمة سعر الذهب، روح قسم الأصول",
  gold: "ذهب",
  purity: "العيار",
  rial: "ريال",
  final_product_price: "سعر المنتج النهائي",
  show_images_right_side: "اعرض الصور يمين",
  show_as_slider: "اعرض كشريط تمرير.",
  show_as_grid: "اعرض كشبكة.",
  show_as_second_mode: "اعرض كالوضع الثاني.",
  gallery_name: "اسم المعرض",
  change_gallery_name: "غير اسم المعرض",
  add_photo: "أضف صورة",
  select_photo: "اختر صورة",
  show_image: "اعرض الصورة",
  selected_photo: "الصورة المختارة",
  to_use_ready_images_search_category_or_product:
    "عشان تستخدم صور جاهزة، ابحث الفئة أو المنتج من فوق.",
  max_file_size_2mb: "أكبر حجم لكل ملف 2 ميغا.",
  drag_and_drop_to_upload_or: "اسحب وأفلت عشان ترفع أو",
  here: "هنا",
  click: "اضغط",
  to_use_external_image_link_fill_fields:
    "عشان تستخدم صورة بلينك خارجي، املأ الحقول تحت",
  image_url_hint: "عنوان (لينك) الصورة اللي تبيها.",
  image_url: "لينك الصورة",
  add_new_gallery: "أضف معرض جديد",
  create_image: "خلق صورة",
  ready_images: "صور جاهزة",
  edit_image: "عدل الصورة",
  enter_valid_link: "دخل لينك صحيح.",
  max_background_image_size_2mb: "أكبر حجم لكل صورة خلفية 2 ميغا.",
  uploaded_successfully: "اترفع بنجاح.",
  banner: "لافتة",
  question: "سؤال",
  selected_question: "السؤال المختار",
  answer: "جواب",
  add_question: "أضف سؤال",
  selected_blog: "المدونة المختارة",
  icon: "أيقونة",
  select_icon: "اختر أيقونة",
  add_blog: "أضف مدونة",
  post: "منشور",
  selected_services: "الخدمات المختارة",
  add_new_post: "أضف منشور جديد",
  add_new_services: "أضف خدمات جديدة",
  add_new_service: "أضف خدمة جديدة",
  domain_must_be_https_or_http:
    "الدومين لازم يكون https://terminalads.com أو terminalads.com.",
  id: "الآي دي",
  images: "الصور",
  tags: "العلامات",
  print_type: "نوع الطباعة",
  user: "المستخدم",
  user_shipping_info: "معلومات الشحن للمستخدم",
  qr_short_link: "لينك مختصر للكيو آر",
  delivery_method: "طريقة التوصيل",
  delivery_at_company: "توصيل بالشركة",
  delivery_by_post: "إرسال بالبريد",
  post_cost_and_tax_warning:
    "بالتسجيل، تكلفة البريد و10% ضريبة تنخصم من محفظتك.",
  shipping_info: "معلومات الشحن",
  continue_shopping: "كمل التسوق",
  complete_shopping: "اكمال الشراء",
  select_free_nfc_card: "اختر بطاقة NFC مجانية",
  order_custom_nfc_card: "اطلب بطاقة NFC مخصصة",
  buy_qr_equipment: "اشتري معدات الكيو آر",
  vertical: "عمودي",
  horizontal: "أفقي",
  card_type: "نوع البطاقة",
  tag: "علامة",
  select: "اختر",
  order_card: "اطلب البطاقة",
  available: "متوفر",
  unavailable: "غير متوفر",
  for_initial_loading: "للتحميل الأول",
  already_have_free_nfc_message:
    "سبق وحصلت NFC مجاني لهالكيو آر. عشان تغير، اشتري بطاقة مخصصة.",
  nfc_in_delivery_process_message:
    "سبق وسجلت NFC مجاني وهو بالتوصيل. عشان تغير، اشتري مخصصة.",
  free_nfc_card_warning_message:
    "عزيزي: بطاقات NFC المجانية مطبوعة سابقًا، كيو آرك يتغير. إذا استخدمته، اشتري مخصصة.",
  select_card: "اختر البطاقة",
  free_card_selection_conditions: "شروط اختيار البطاقة المجانية",
  confirm_and_select: "تأكيد واختيار",
  registered_successfully: "اتسجل بنجاح.",
  error_registering_nfc_order: "خطأ بتسجيل طلب بطاقة NFC!",
  nfc_physical_card_orders: "طلبات بطاقات NFC الفيزيائية",
  buy_equipment: "اشتري المعدات",
  select_quantity: "اختر الكمية",
  ready_samples: "عينات جاهزة",
  upload_custom_design: "ارفع تصميم مخصص",
  select_ready_card_image: "اختر صورة بطاقة جاهزة",
  select_card_front_image: "اختر صورة وجه البطاقة",
  select_card_back_image: "اختر صورة ظهر البطاقة",
  nfc_card_image: "صورة بطاقة NFC",
  add_quantity: "أضف كمية",
  total_price: "السعر الكلي",
  price_with_discount: "السعر ويا الخصم",
  shipping_cost: "تكلفة الشحن",
  your_profit_from_purchase: "ربحك من الشراء",
  discount: "الخصم",
  ten_percent_tax_will_be_added: "10% ضريبة تضاف للمبلغ النهائي.",
  payable_amount: "المبلغ المستحق",
  continue: "كمل",
  Confirm_code: "تأكيد الكود",
  form_success_message: "نموذجك وصل بنجاح",
  refill_form_message: "املأ النموذج مرة ثانية",
  Enter_the_sent_code: "دخل الكود اللي وصلك",
  SUBMIT_FORM: "ارسل النموذج",
  enter_phone_number: "دخل رقم جوالك",
  order_registered_successfully: "طلبك اتسجل بنجاح.",
  smart_creation: "خلق ذكي",
  automatic_creation: "خلق تلقائي",
  business_name: "اسم البيزنس",
  example_household_goods: "مثال: أدوات منزلية",
  organization_name: "اسم المنظمة",
  example_tech_company: "مثال: شركة تكنولوجيا متقدمة",
  minimum_two_characters_required: "لازم تدخل حرفين على الأقل!",
  maximum_100_characters_allowed: "أكبر 100 حرف",
  latin_name_qr_address: "الاسم اللاتيني (عنوان الكيو آر)",
  example_advanced_tech: "مثال: advanced-tech",
  only_english_numbers_dash_allowed: "بس حروف إنجليزي، أرقام وشرطة",
  maximum_50_characters_allowed: "أكبر 50 حرف",
  latin_name_goes_after_domain: "الاسم اللاتيني يجي بعد الدومين",
  select_logo_and_store_product_image: "اختر اللوغو وصورة الدكان/المنتج",
  select_logo: "اختر اللوغو",
  file_size_must_be_less_than_2mb: "حجم الملف لازم أقل من 2 ميغا",
  for_buying_renewing_qr_click_expiry_button:
    "عشان تشتري/تجدد الكيو آر، اضغط زر مدة الانتهاء.",
  for_group_renewal_select_desired_qr_codes:
    "لتجديد جماعي، اختر الكيو آر اللي تبيه.",
  no_qr_found_with_these_filters: "ما لكينا كيو آر بهالفلاتر!",
  i_buy: "اشتري",
  visits: "الزيارات",
  creation_time: "وقت الخلق",
  edit_time: "وقت التعديل",
  enter_business_card_name_correctly: "دخل اسم بطاقة الأعمال صح!",
  are_you_sure_delete_qr: "متأكد تحذف الكيو آر؟",
  qr_deleted_successfully: "الكيو آر اتحذف بنجاح.",
  are_you_sure_deactivate_qr: "متأكد توقف الكيو آر؟",
  are_you_sure_activate_qr: "متأكد تفعل الكيو آر؟",
  deactivated: "متوقف",
  qr_successfully: "الكيو آر بنجاح",
  successfully: "تم",
  user_transferred_successfully: "المستخدم انتقل بنجاح",
  problem_occurred_in_transfer: "صارت مشكلة بالنقل!",
  error_in_user_transfer: "خطأ بنقل المستخدم!",
  qr_business_card_edited_successfully: "بطاقة الأعمال تبعك اتعدلت بنجاح.",
  group_qr_renewal: "تجديد جماعي للكيو آر",
  select_desired_duration: "اختر المدة اللي تبيها",
  total_count: "العدد الكلي",
  final_amount: "المبلغ النهائي",
  ten_percent_vat_will_be_added: "10% ضريبة القيمة المضافة تضاف للمبلغ فوق.",
  pay_and_upgrade: "ادفع وطور",
  no_tariff_for_this_period: "ماكو تعرفة لهالفترة!",
  selected: "مختار",
  total_amount: "المبلغ الكلي",
  final_amount_with_discount: "المبلغ النهائي ويا الخصم",
  add_qr: "أضف كيو آر",
  actions: "الإجراءات",
  filter_type: "فلتر النوع",
  start_from: "ابدأ من",
  search_in_id: "ابحث بالآي دي",
  filter_user: "فلتر المستخدم",
  clear_filters: "امسح الفلاتر",
  send_sms: "ارسل رسالة نصية",
  selected_pattern: "النمط المختار",
  send: "ارسل",
  bulk_download: "تحميل جماعي",
  one_month_renewal: "تجديد شهري",
  three_month_renewal: "تجديد ثلاث شهور",
  six_month_renewal: "تجديد ست شهور",
  one_year_renewal: "تجديد سنوي",
  no_item_selected: "ما مختار أي شي!",
  error_loading_card_info: "خطأ بتحميل معلومات البطاقة!",
  send_registered_successfully: "الإرسال اتسجل بنجاح",
  error_getting_prices: "خطأ باستلام الأسعار!",
  payment_error: "خطأ بالدفع!",
  business_card: "بطاقة أعمال",
  product_label: "تسمية المنتج",
  restaurant_menu: "قائمة المطعم",
  event_ticket: "تذكرة الحدث",
  brochure: "كتيب",
  flyer: "نشرات",
  poster: "ملصق",
  catalog: "كتالوج",
  newsletter: "نشرة إخبارية",
  organization_name_hint: "دخل اسم منظمتك.",
  organization_name_label: "اسم المنظمة",
  sub_organization_hint: "دخل الاسم الفرعي للمنظمة.",
  sub_organization_label: "وصف الاسم الفرعي للمنظمة",
  user_name_hint: "دخل اسمك.",
  user_name_label: "الاسم واللقب",
  work_field_hint: "دخل منصبك الوظيفي.",
  work_field_label: "المنصب",
  mobile_number_hint: "دخل رقمك.",
  mobile_number_label: "رقم الجوال",
  phone_number_hint: "دخل رقم الهاتف.",
  phone_number_label: "رقم الهاتف",
  email_hint: "دخل إيميلك.",
  email_label: "الإيميل",
  fax_hint: "دخل فاكس الشركة.",
  fax_label: "فاكس الشركة",
  website_hint: "دخل موقع الشركة.",
  website_label: "موقع الشركة",
  postal_code_hint: "دخل الرمز البريدي.",
  postal_code_label: "الرمز البريدي",
  copyright_hint: "دخل نص حقوق النشر بالتذييل.",
  copyright_label: "نص حقوق النشر",
  address_hint: "دخل عنوانك.",
  address_label: "العنوان",
  add_more_info: "أضف معلومات أكثر اللي تبيها:",
  edit_location: "عدل",
  add_location: "أضف",
  delete_location: "احذف الموقع",
  about_us_label: "عنا",
  search_address: "ابحث عن العنوان:",
  northern_coordinates: "إحداثيات شمالية",
  eastern_coordinates: "إحداثيات شرقية",
  select_address_on_map: "اختر العنوان على الخريطة",
  location_not_found: "ما لكينا الموقع.",
  text_label: "النص",
  number_label: "الرقم",
  website_address_label: "عنوان الموقع",
  location_label: "الموقع",
  mobile_viewer_title: "عارض الجوال",
  visit_theme_two_title: "ثيم بطاقة الزيارة الثاني",
  visit_theme_flipped_title: "ثيم بطاقة الزيارة المقلوب",
  flip_card: "قلب البطاقة",
  flip_card_description: "عشان تشوف معلومات أكثر، قلب البطاقة",
  share_contacts: "شارك جهات الاتصال",
  close_share: "سد المشاركة",
  card_front: "وجه البطاقة",
  card_back: "ظهر البطاقة",
  flip_to_back: "قلب للخلف",
  flip_to_front: "قلب للأمام",
  swipe_to_flip: "اسحب عشان تقلب",
  swipe_left: "اسحب يسار",
  swipe_right: "اسحب يمين",
  expand_card: "وسع البطاقة",
  contract_card: "صغر البطاقة",
  view_details: "شوف التفاصيل",
  hide_details: "اخفِ التفاصيل",
  social_media_share: "مشاركة وسائل التواصل",
  contact_actions: "إجراءات الاتصال",
  card_actions: "إجراءات البطاقة",
  floating_menu: "قائمة عائمة",
  close_menu: "سد القائمة",
  open_menu: "افتح القائمة",
  choice_gallery: "المعرض المختار",
  choice_video: "اختر الفيديو",
  url_video: "لينك الفيديو",
  selected_video: "الفيديو المختار",
  add_video: "أضف فيديو",
  edit_video: "عدل الفيديو",
  linl_video: "لينك النقل",
  upload_video: "ارفع الفيديو",
  rule_link: "الدومين لازم يكون https://terminalads.com أو terminalads.com.",
  fax_hint: "دخل فاكس الشركة.",
  fax_label: "فاكس الشركة",
  website_hint: "دخل موقع الشركة.",
  website_label: "موقع الشركة",
  postal_code_hint: "دخل الرمز البريدي.",
  postal_code_label: "الرمز البريدي",
  add_more_info: "أضف معلومات أكثر اللي تبيها:",
  address_hint: "دخل عنوانك.",
  address_label: "العنوان",
  edit_location: "عدل",
  add_location: "أضف",
  delete_location: "احذف الموقع",
  location_label: "الموقع",
  about_company_label: "عن الشركة",
  select_address_on_map: "اختر العنوان على الخريطة",
  search_address: "ابحث عن العنوان:",
  rule_link: "الدومين لازم يكون https://terminalads.com أو terminalads.com.",
  link_label: "عنوان اللينك",
  label_label: "العنوان",
  field_value_label: "قيمة الحقل",
  add_new_field: "أضف حقل جديد",
  tehran_address: "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6",
  welcome_message_hint:
    "إذا فعلت هذا، لما ينضم الزبون لناديكم، يوصل رسالة ترحيب.",
  change_pattern_campaign: "غير النمط/الحملة",
  selected_message: "الرسالة المختارة:",
  required_inputs: "المدخلات الإلزامية:",
  selected_campaign_or_pattern: "الحملة/النمط المختار:",
  campaign: "حملة",
  pattern: "نمط",
  id: "الآي دي",
  auto_csv_download_label: "حفظ تلقائي",
  auto_csv_download_hint:
    "بعد فتح البطاقة، معلوماتك تنزل تلقائي على جوال الزبون.",
  show_cclub_onload_label: "اقتراح العضوية",
  show_cclub_onload_hint: "نافذة تنفتح للانضمام لنادي الزبائن.",
  forced_submission_hint: "ويا عرض نموذج العضوية، لازم الزبون يسجل رقمه.",
  forced_submission_forced: "عضوية إلزامية",
  forced_submission_optional: "عضوية اختيارية",
  has_manifest_icons_label: "تخصيص تطبيق الويب",
  has_assistant_label: "تسمية المساعد",
  select_assistant: "اختار المساعد",
  assistant_ai: "مساعد الذكاء الاصطناعي",
  has_manifest_icons_hint:
    "اللوغو والصورة تظهر لما يثبت تطبيق الويب على الجوال أو الكمبيوتر.",
  logo_144px: "لوغو 144 بكسل",
  logo_48px: "لوغو 48 بكسل",
  photo_wide: "صورة عريضة",
  photo: "صورة",
  iranian_social_networks: "شبكات تواصل إيرانية",
  foreign_social_networks: "شبكات تواصل أجنبية",
  advertising_sites: "مواقع إعلانية",
  other_links: "لينكات ثانية",
  custom_text: "نص مخصص",
  custom_text_placeholder: "دخل نصك المخصص.",
  aparat: "أبارات",
  aparat_hint: "دخل اسم قناتك بأبارات",
  eitaa: "إيتا",
  eitaa_hint: "دخل اسم المستخدم تبعك",
  soroush: "سروش",
  soroush_hint: "دخل اسم المستخدم تبعك",
  bale: "بالي",
  bale_hint: "دخل اسم المستخدم تبعك",
  rubika: "روبيكا",
  rubika_hint: "دخل لينك القناة/المجموعة",
  gap: "غاب",
  gap_hint: "دخل اسم المستخدم تبعك",
  linkedin: "صفحة لينكدإن الشخصية",
  linkedin_hint: "أدخل اسم المستخدم الخاص بك",
  linkedin_company: "صفحة الشركة على لينكدإن",
  linkedin_company_hint: "أدخل اسم صفحة الشركة الخاصة بك",
  pinterest: "بينترست",
  pinterest_hint: "دخل اسم المستخدم تبعك",
  dribbble: "دريبل",
  dribbble_hint: "دخل اسم المستخدم تبعك",
  facebook: "فيسبوك",
  facebook_hint: "دخل اسم المستخدم تبعك",
  github: "غيت هاب",
  github_hint: "دخل اسم المستخدم تبعك",
  threads: "ثريدز",
  threads_hint: "دخل اسم المستخدم تبعك",
  tiktok: "تيك توك",
  tiktok_hint: "دخل اسم المستخدم تبعك",
  twitter: "تويتر",
  twitter_hint: "دخل اسم المستخدم تبعك",
  skype: "سكايب",
  skype_hint: "دخل اسم المستخدم تبعك",
  youtube: "يوتيوب",
  youtube_hint: "دخل اسم المستخدم بدون @",
  wechat: "وي تشات",
  wechat_hint: "دخل اسم المستخدم تبعك",
  viber: "فايبر",
  viber_hint: "دخل اسم المستخدم تبعك",
  divar: "ديوار",
  divar_hint: "دخل لينك الإعلان/اللوحة/الدكان",
  sheypoor: "شيبور",
  sheypoor_hint: "دخل لينك الإعلان/اللوحة/الدكان",
  social_network: "شبكة اجتماعية",
  photo_logo_tab: "صورة/لوغو",
  gallery_image_tab: "معرض صور",
  template_image: "صورة القالب",
  background_image: "صورة الخلفية",
  upload_logo: "ارفع اللوغو",
  welcome_image_upload: "ارفع صورة/لوغو الترحيب",
  welcome_photo: "صورة الترحيب",
  loading_animation: "تحريك التحميل",
  preview_welcome_page: "شوف معاينة صفحة الترحيب",
  default_template_image: "صورة خلفية القالب",
  default_background_image: "صورة الخلفية",
  default_logo: "اللوغو",
  default_welcome: "الترحيب",
  default_gallery: "المعرض",
  animation_scale: "كبر من الوسط",
  animation_slide_x: "دخل من اليسار",
  animation_slide_y: "دخل من فوق",
  animation_fade: "يختفي",
  image_size_error: "أكبر حجم لكل صورة خلفية 2 ميغا.",
  logo_size_error: "أكبر حجم لكل لوغو 2 ميغا.",
  categories: {
    bankcard: 'بطاقة مصرفية',
    bale: "بله",
    robika: "روبيكا",
    eitaa: "إيتا",
    text: "نص",
    multi_card: "بطاقة متعددة",
    product_introduction_pro: "تقديم منتج برو",
      "gift": "هدية",
    electronic_business_card_pro: "بطاقة الأعمال الإلكترونية برو",
    link_pro:"لينك برو",
    generated_images: "الصور اللي اتخلقت",
    electronic_business_card: "بطاقة أعمال إلكترونية",
    social_media: "وسائل التواصل",
    photo_gallery: "معرض صور",
    video_gallery: "معرض فيديو",
    link: "لينك",
    audio_gallery: "معرض صوت",
    audio_gallery_pro: "معرض صوت (برو)",
    feedback: "ردود الفعل",
    consultation_form: "نموذج طلب استشارة",
    application: "تقديم التطبيق",
    pdf_gallery: "معرض PDF",
    schedule_table: "جدول الجدولة",
    personal_company_website: "موقع شخصي/شركة",
    online_store: "دكان أونلاين",
    online_menu: "قائمة أونلاين",
    appointment_booking: "حجز موعد",
    commercial_admin_website: "موقع مجمع تجاري/إداري",
    online_insurance_sales: "بيع تأمين أونلاين",
    discount_code: "كود خصم",
    product_introduction: "تعريف المنتج",
    product_label: "تسمية المنتج",
    gold_label: "تسمية الذهب",
    franchise: "فرانشايز (صفحة بيزنس)",
    marketplace: "ماركت بليس (صفحة بيزنس)",
    recruitment_form: "نموذج توظيف",
    organizational_form: "نموذج تنظيمي",
    employee_card: "بطاقة موظف",
    book_magazine: "كتاب/مجلة",
    catalog_brochure: "كتالوج/كتيب",
    catalog: "كتالوج",
    faq: "أسئلة شائعة",
    feedback_survey: "ردود فعل / استطلاع رأي",
    consultation_request: "طلب استشارة",
    customer_club: "نادي الزبائن",
    invitation_card: "بطاقة دعوة",
    countdown: "عد تنازلي",
    tombstone: "شاهد قبر",
  },
  support_day60: "ضمان استرداد الفلوس لمدة 60 يوم",
  "enter_visit_card_pro_info": "دخل اسم البطاقة الشخصية برو",
  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "تعديل نص رمز QR",
          SERVER_DOWN: "جاري التحديث",
    CREATE_MEMORIES_MODEL: "إنشاء نموذج إطار الذكريات",
    CREATE_CARD_VISIT_PRO_MODEL: "إنشاء نموذج بطاقة العمل الاحترافية",
    CREATE_PRODUCT_PRO_MODEL: "إنشاء نموذج تعريف المنتج الاحترافي",
    CREATE_PRODUCT_LABEL_MODEL: "إنشاء نموذج ملصق المنتج",
    CREATE_PHOTO_GALLERY_MODEL: "إنشاء نموذج معرض الصور",
    CREATE_PDF_GALLERY_MODEL: "إنشاء نموذج معرض ملفات PDF",
    CREATE_SOCIAL_MEDIA_MODEL: "إنشاء نموذج وسائل التواصل الاجتماعي",
    EDIT_CARD_VISIT_PRO_MODEL: "تعديل نموذج بطاقة العمل الاحترافية",
    EDIT_PRODUCT_PRO_MODEL: "تعديل نموذج تعريف المنتج الاحترافي",
    EDIT_PRODUCT_LABEL_MODEL: "تعديل نموذج ملصق المنتج",
    EDIT_PHOTO_GALLERY_MODEL: "تعديل نموذج معرض الصور",
    EDIT_PDF_GALLERY_MODEL: "تعديل نموذج معرض ملفات PDF",
    EDIT_SOCIAL_MEDIA_MODEL: "تعديل نموذج وسائل التواصل الاجتماعي",
    BOOK: "كتاب",
    NFC_LIST: "قائمة بطاقات NFC",
    API_KEY_MANAGER: "إنشاء مفتاح API",
    PRE_PURCHASE: "الشراء المسبق",
    PRE_PURCHASE_MODEL: "نموذج جاهز",
      "QR_NAME_EDIT_GIFT": "تعديل باركود الهدية",
      "QR_GIFT": "باركود الهدية",
      "QR_NAME_EDIT_PRO": "تعديل رمز الاستجابة السريعة للرابط برو",
      "QR_LINK_PRO": "كيوار لينك برو",
      DIGI: "مراقبة أسعار ديجي كالا",
      QR_PDF: "معرض الـ PDF",
      QR_NAME_EDIT_PDF: "تحرير معرض الـ PDF",
      QR_MULTICART: "كارت الـ QR المتعدد",
      QR_MULTICART_EDIT: "تحرير كارت الـ QR المتعدد",
      QR_NAME_PRODUCTPRO: "تعديل تعريف منتج برو",
      QR_PRODUCTPRO: "تعريف منتج برو",
      QR_NAME_EDIT_CATALOG: "تعديل الكتالوج",
      QR_LUCK_WHEEL_Edit: "تعديل دولاب الحظ",
      QR_LUCK_WHEEL: "عمل كود QR لعجلة الحظ",
      DASHBOARD: "لوحة التحكم",
      ADMIN_QR_DOMAINS: "مراقبة الدومينات",
      ADMIN_TOGETHER_TOKEN: "مراقبة التوكنات",
      ADMIN_QR_SMS: "إرسال الرسايل النصية",
      MENU_PROFILE_INFO: "معلومات المستخدم",
      MENU_PROFILE_SETTING: "إعدادات البروفايل",
      MENU_PROFILE_ORDERS: "الطلبات",
      MENU_PROFILE_ADDRESSES: "العناوين",
      QR_MONITORING: "مراقبة الكيو آر",
      QR_LIST: "قائمة الكيو آر الخاصة بي",
      QR_NAME_LIST: "إدارة المشاركة",
      QR_GENERATE_MULTIPLE: "إنشاء كيو آر جماعي",
      QR_CARD_VISIT: "إنشاء كارت فيزيت",
      HELP_INFO: "اختبار الزر",
      QR_MENU: "منيو المتجر",
      QR_APPOINTMENT: "حجز موعد",
      QR_INSURANCE: "إنشاء تأمين أونلاين",
      QR_BPAGE: "إنشاء صفحة عمل",
      QR_CPAGE: "إنشاء موقع مجمع تجاري/إداري",
      QR_BSHOP: "متجر إلكتروني",
      QR_NAME_EDIT_BSHOP: "تعديل المتجر الإلكتروني",
      QR_LINK_EDIT: "تعديل الرابط",
      QR_NAME_DESIGN: "تعديل التصميم",
      QR_NAME_SETTING: "تعديل الإعدادات",
      QR_NAME_EDIT: "تعديل كارت الفيزيت",
      QR_NAME_EDIT_BPAGE: "تعديل صفحة العمل",
      QR_EDIT_CPAGE: "تعديل موقع المجمع التجاري/الإداري",
      QR_NAME_INSURANCE: "تعديل التأمين أونلاين",
      QR_NAME_EDIT_MENU: "تعديل المنيو",
      QR_NAME_EDIT_APPLICATION: "تقديم التطبيق",
      QR_NAME_EDIT_APPOINTMENT: "تعديل حجز الموعد",
      QR_NAME_EDIT_PHOTO: "تعديل معرض الصور",
      QR_NAME_EDIT_VIDEO: "تعديل معرض الفيديو",
      QR_NAME_EDIT_VOICE: "تعديل معرض الصوت",
      QR_NAME_EDIT_FEEDBACK: "تعديل معرض التعليقات",
      QR_NAME_CONSULTATION_QR_EDIT: "تعديل نموذج الطلب",
      QR_NAME_EDIT_VOICE_PRO: "تعديل معرض الصوت (برو)",
      QR_NAME_EDIT_SOCIAL: "تعديل الشبكات الاجتماعية",
      QR_NAME_STATISTICS: "إحصائيات الكيو آر",
      QR_CATE: "اختيار الفئة",
      QR_SHARE: "مشاركة",
      QR_BUSINESS_SHOP: "بيزنس/متجر",
      QR_CO_ORGAN: "شركة/منظمة",
      QR_CONTACT: "اتصال بالزبون",
      QR_NOTICES: "إشعارات",
      QR_OTHERS: "متنوع",
      QR_STATICS: "كيو آر ثابت",
      QR_DYNAMICS: "كيو آر ديناميكي",
      QR_D_BUSINESS: "كيو آر ديناميكي بيزنس",
      QR_D_ORGANS: "كيو آر ديناميكي تنظيمي",
      QR_D_GOVERNMENT: "كيو آر ديناميكي حكومي",
      QR_VIDEO: "معرض الفيديو",
      QR_APPLICATION: "تقديم التطبيق",
      QR_VOICE: "معرض الصوت",
      QR_VOICE_PRO: "معرض الصوت (برو)",
      QR_CONSULTATION_QR: "نموذج الطلب",
      QR_FEEDBACK: "معرض التعليقات",
      QR_PHOTO: "معرض الصور",
      QR_CATALOG: "كتالوج / بروشور",
      QR_LOCATION: "إنشاء كيو آر للموقع",
      QR_SOCIAL_MEDIA: "إنشاء كيو آر للشبكات الاجتماعية",
      QR_LINK: "إنشاء رابط",
      QR_TEXT: "إنشاء نص",
      QR_MAIL: "إنشاء إيميل",
      QR_CALL: "اتصال",
      QR_SMS: "رسالة نصية",
      QR_WHATSAPP: "واتساب",
      QR_SITE: "موقع إلكتروني",
      QR_INSTAGRAM: "إنستغرام",
      QR_SKYPE: "سكايب",
      QR_WIFI: "واي فاي",
      QR_BUSINESS: "صفحة عمل",
      QR_DISCOUNT: "صفحة الخصم",
      QR_PRODUCT_SHOP: "تقديم المنتج",
      QR_PRODUCT_LABEL: "ليبل المنتج",
      QR_GOLD_LABEL: "ليبل الذهب",
      QR_PRODUCT_TEMPLATE: "المنتجات",
      ADMIN_CATEGORY: "الفئات",
      QR_NFC_ORDERS: "كروت NFC بانتظار التأكيد",
      QR_NAME_PRODUCT: "تعديل تقديم المنتج",
      QR_NAME_LABELPRODUCT: "تعديل ليبل المنتج",
      QR_NAME_GOLDPRODUCT: "تعديل ليبل الذهب",
      QR_COINS: "العملات المشفرة",
      QR_SHOP: "إدارة المتجر",
      QR_TWITTER: "تويتر",
      UPLOAD_CENTER: "مركز الرفع",
      PRICING: "تعريفات الكيو آر",
      QR_CREATE_MODELS: "إنشاء نموذج كارت فيزيت",
      QR_CREATE_BUSINESS_MODELS: "إنشاء نموذج صفحة عمل",
      QR_CREATE_PRODUCT_MODEL: "إنشاء نموذج كارت منتج",
      QR_CREATE_MENU_MODELS: "إنشاء نموذج منيو متجر",
      QR_CREATE_SHOP_MODEL: "إنشاء نموذج متجر إلكتروني",
      MODELS_LIST: "أنواع نماذج الكيو آر",
      MODELS_LIST_EDIT: "تعديل النموذج",
      MODELS_LIST_MENU_EDIT: "تعديل نموذج المنيو",
      MODELS_LIST_BMODEL_EDIT: "تعديل نموذج المتجر الإلكتروني",
      NFC: "كروت NFC",
      SUBMIT_FORM: "تسجيل البلوجر",
      REQUEST_LIST: "قائمة البلوجرز",
      PURE_DATA: "قائمة كروت الفيزيت الغير مبنية",
      AUTO_CREATE: "إنشاء تلقائي للكيو آر",
      QR_CREATE: "إنشاء كيو آر",
      HISTORY_REMINDER: "مراقبة التذكير",
      BOOK: "مراقبة التذكير"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "طرق الدفع",
      ORDER_NOTIFICATIONS: "إشعارات الطلبات",
      DISCOUNT_CODE: "كود الخصم",
      CART: "سلة التسوق",
      TABLE_MANAGEMENT: "إدارة الطاولات",
    },
    ERRORS: {
      INVALID_INPUT: "ادخل القيم بشكل صحيح!",
      CART_SETTINGS_FAILED: "إعدادات سلة التسوق فشلت!",
    },
  },
  popup: {
    prepared_stores_title: "عينات متاجر إلكترونية جاهزة",
  },
  buttons: {
    reset_defaults: "إعادة تعيين البيانات الافتراضية",
    download_qr: "تحميل الكيو آر",
    cleardefaults: "حذف المعلومات الافتراضية",
    select_prepared_store: "اختيار متجر إلكتروني جاهز",
  },
  stepper: {
    create_qr: "إنشاء كيو آر",
    products_info: "المنتجات والمعلومات",
    content_settings: "إعدادات المحتوى",
    sales_settings: "إعدادات المبيعات",
  },
  fields: {
    online_store_name: "اسم المتجر الإلكتروني",
    qr_address: "عنوان الكيو آر",
    qr_address_hint: "ادخل عنوان الكيو آر الخاص بك",
    online_sale: "البيع أونلاين",
  },
  login_settings: "إعدادات تسجيل الدخول",
  shop_logo_and_images: "لوغو وصور المتجر",
  login_page_info: "معلومات صفحة تسجيل الدخول",
  upload_banner: "رفع البانر",
  create_product: "إنشاء منتج",
  special_sale: "بيع خاص",
  ended: "منتهي",
  blog: "بلوغ",
  services: "خدمات",
  pdf_gallery: "معرض PDF",
  create_section: "إنشاء قسم",
  achievements: "الإنجازات",
  team_members: "أعضاء الفريق",
  working_hours: "ساعات العمل",
  saturday: "السبت",
  sunday: "الأحد",
  monday: "الإثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  we_will_be_different: "راح نكون مختلفين...",
  striving_for_excellence: "نسعى دايمًا نكون الأفضل >>> لأجلك",
  online_store_ready_15_minutes: "متجرك الإلكتروني جاهز بـ15 دقيقة!",
  sales_management: "إدارة المبيعات",
  dear_customer_online_stores:
    "عزيزي الزبون، تقدر تشتري من متاجرنا الإلكترونية الثانية بعد:",
  divar_site: "موقع ديوار",
  digikala_site: "موقع ديجي كالا",
  basalam_site: "موقع باسلام",
  torob_site: "موقع ترب",
  emalls_site: "موقع إيمالز",
  copyright_qrland: "كل الحقوق محفوظة لـ QR Land.",
  tehran_address: "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6",
  our_achievements: "إنجازات مجموعتنا",
  customer_satisfaction: "رضا الزبائن",
  lowest_returns: "أقل المرتجعات",
  loyal_customer: "زبون مخلص",
  shipped_orders: "طلبات مشحونة",
  visit_our_videos: "شوف فيديوهات مجموعتنا.",
  bringing_the_best: "جايبينلك الأفضل...",
  feedback_important: "تعليقاتك مهمة إلنا",
  guide_us_with_feedback: "جاوب على الأسئلة اللي جوه عشان نساعدك أحسن.",
  satisfied_with_quality: "راضي عن جودة المنتجات؟",
  evaluate_packaging_quality: "شلون تقيّم جودة التغليف؟",
  satisfied_with_variety: "راضي عن تنوع المنتجات؟",
  benefited_from_discounts: "استفدت من خصومات هذا المتجر؟",
  post_1: "بوست 1",
  fast_order_delivery: "تسليم الطلب بسرعة",
  post_2: "بوست 2",
  post_3: "بوست 3",
  product_authenticity_guarantee: "ضمان أصالة المنتج",
  comfortable_purchase: "تسوق مريح",
  how_to_place_order: "شلون أقدر أسجل طلبي؟",
  add_to_cart: "أضف المنتجات اللي تبيها لسلة التسوق.",
  how_to_register: "شلون أقدر أسجل بالموقع؟",
  click_login_and_enter_code:
    "اضغط على زر 'تسجيل الدخول'، ادخل رقم موبايلك وكود الرسالة.",
  delivery_time: "كم ياخذ وقت طلبي يوصل بعد التسجيل؟",
  fastest_delivery: "يتم شحن طلبك بأسرع وقت.",
  shipping_cost: "كم تكلفة شحن الطلب؟",
  shipping_cost_order: "تكلفة شحن الطلب",
  variable_shipping_cost: "تكلفة الشحن تختلف حسب عنوانك.",
  change_or_cancel_order: "أقدر أغير أو ألغي الطلب بعد التسجيل؟",
  no_change_or_cancel: "لا، ما يصير تغيير أو إلغاء.",
  mrs_Safdarian: "السيدة صفدريان",
  invalid_address: "العنوان المدخل مو صحيح!",
  shop_page_created_success: "صفحة المتجر انبنات بنجاح.",
  qr_creation_failed: "فشل إنشاء الكيو آر!",
  server_error: "خطأ بالسيرفر!",
  qr_card_updated_success: "كارت الفيزيت اتعدل بنجاح.",
  qr_save_edit_failed: "خطأ بحفظ/تعديل الكيو آر",
  your_feedback: "تعليقك",
  digital_marketing_strategy:
    "ضع شركتك على الطريق الصحيح مع استراتيجي التسويق الرقمي",
  wait_for_default_products:
    "انتظر شوية لحد ما المنتجات الافتراضية تحمل كاملة بموقعك.",
  template_categories_saved: "فئات النموذج اتحفظت بنجاح.",
  template_products_saved: "منتجات النموذج اتحفظت بنجاح.",
  template_products_save_failed: "خطأ بحفظ منتجات النموذج!",
  template_categories_save_failed: "خطأ بحفظ فئات النموذج!",
  login_page_text: "نص صفحة تسجيل الدخول",
  persian_error: "النص لازم يكون بالفارسية",
  number_error: "البيانات لازم تكون أرقام وما تكون فاضية",
  english_error: "النص ما لازم يكون غير إنجليزي أو فاضي",
  mixPerEng_error: "النص ما لازم يكون غير إنجليزي أو غير فارسي أو فاضي",
  email_error: "تنسيق الإيميل مو صحيح",
  mobile_error: "تنسيق الرقم مو صحيح",
  meliCode_error: "تنسيق الكود الوطني مو صحيح",
  site_error: "تنسيق الموقع مو صحيح",
  min_length_error: "القيمة ما تقدر تكون أقل من {{min}}",
  max_length_error: "القيمة ما تقدر تكون أكثر من {{max}}",
  form_submitted_message: "النموذج ارسل بنجاح",
  required_fields_error: "القيم الإلزامية ما دخلت",
  headphone_title: "سماعات الرأس",
  buy_button: "اشتري",
  day: "يوم",
  hour: "ساعة",
  minute: "دقيقة",
  second: "ثانية",
  required_field_error: "{{fieldName}} إلزامي",
  submit_request_button: "تسجيل الطلب",
  request_submitted_success: "طلبك سجل بنجاح",
  feedback_submitted_success: "تعليقك سجل بنجاح",
  description_required_label: "الوصف (إلزامي)",
  description_optional_label: "الوصف (اختياري)",
  description_hint: "ادخل الوصف اللي تبيه بهذا الحقل (3 أحرف على الأقل)",
  footer: {
    position: "الجانب",
    contactUs: "اتصل بينا",
    aboutUs: "عنّا",
    firstShift: "الوردية الأولى",
    secondShift: "الوردية الثانية",
    startTime: "وقت البداية",
    endTime: "وقت النهاية",
    features: "الميزات",
    partners: "الشركاء",
    affiliates: "البرامج التابعة",
    panels: "اللوحات",
    supportTicket: "تذكرة الدعم",
    inPersonServices: "خدمات حضورية",
    liveChat: "دردشة مباشرة",
    faq: "الأسئلة الشائعة",
    add_secondshift: "إضافة وردية ثانية",
    firstDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
  },
  qr_management: "إدارة الكيو آر",
  restore_default_questions: "استعادة الأسئلة الافتراضية",
  delete_all: "حذف الكل",
  edit_question: "تعديل السؤال",
  move_up: "للأعلى",
  move_down: "للأسفل",
  delete: "حذف",
  selected_question: "السؤال المختار",
  question: "سؤال",
  answer_type: "نوع الإجابة",
  excellent: "ممتاز",
  good: "جيد",
  very_poor: "ضعيف جدًا",
  response_optionality: "اختياري / إلزامي الإجابة",
  required: "إلزامي",
  optional: "اختياري",
  add_new_question: "إضافة سؤال جديد",
  satisfied_with_quality: "راضي عن جودة المنتجات؟",
  evaluate_packaging_quality: "شلون تقيّم جودة التغليف؟",
  satisfied_with_variety: "راضي عن تنوع المنتجات؟",
  benefited_from_discounts: "استفدت من خصومات هذا المتجر؟",
  suggestions_for_improvement: "شنو اقتراحك لتحسين تجربة التسوق بهذا المتجر؟",
  confirm_delete_question: "حذف السؤال المختار؟",
  question_deleted_success: "السؤال اتحذف بنجاح.",
  question_delete_failed: "خطأ بحذف السؤال!",
  confirm_delete_all_questions: "متأكد تحذف كل الأسئلة؟",
  questions_deleted_success: "الأسئلة اتحذفت بنجاح.",
  questions_delete_failed: "خطأ بحذف الأسئلة!",
  invalid_input: "ادخل القيم بشكل صحيح!",
  operation_failed: "العملية فشلت!",
  question_number: "سؤال {number}؟",
  card_subtitle: "ادخل قصة الصورة اللي تبيها، والذكاء الاصطناعي يخلقها لك.",
  upgrade_label: "إرفاق",
  free: " - مجانًا",
  language_select: "اختيار اللغة لكتابة نص الطلب",
  image_size: "حجم الصورة",
  prompt_label: "نص الطلب",
  prompt_placeholder: "صف الصورة اللي تبيها...",
  generate_image: "إنشاء صورة",
  regenerate_image: "إنشاء صورة جديدة",
  save_image: "حفظ الصورة",
  save_image_subtitle: "الصورة اللي فوق بس اللي تحفظ.",
  size_items: {
    "16:9": "16:9 (أفقي)",
    "9:16": "9:16 (عمودي)",
    "1:1": "1:1 (مربع)",
  },
  lang_items: {
    fa: "Fa | الفارسية",
    en: "En | الإنجليزية",
    ar: "Ar | العربية",
  },
  rules: {
    empty: "لازم تدخل 3 أحرف على الأقل!",
    spell_checker: "النص لازم يكون باللغة {language}!",
  },
  ERRORS: {
    VpnDetectedTitle: "اطفي الـ VPN",
    VpnDetectedSubtitle: "هذا يساعد النظام يشتغل أحسن ويعطيك تجربة أفضل.",
  },
  errors: {
    VpnDetectedTitle: "اطفي الـ VPN",
    VpnDetectedSubtitle: "هذا يساعد النظام يشتغل أحسن ويعطيك تجربة أفضل.",
    invalid_size: "ادخل العرض والارتفاع بشكل صحيح!",
    image_generation_error: "خطأ بإنشاء الصورة",
    image_upload_error: "خطأ برفع الصورة!",
    service_unavailable:
      "ما يصير تستخدم هالخدمة - صار غلط والبيانات ما تحملت من السيرفر",
    qr_address_taken: "هذا عنوان الـQR مستخدم من قبل",
  },
  add_working_time: "إضافة وقت العمل",
  selected_day: "اليوم المختار",
  range_name: "اسم الفترة الزمنية",
  add: "إضافة",
  first_shift: "الوردية الأولى",
  second_shift: "الوردية الثانية",
  start_time: "وقت البداية",
  end_time: "وقت النهاية",
  date_range: "الفترة الزمنية",
  all_week_days: "كل أيام الأسبوع",
  saturday_to_wednesday: "السبت للأربعاء",
  saturday_to_thursday: "السبت للخميس",
  work_week: "كل أيام الأسبوع (ما عدا أيام العطل)",
  feedbacks: "التعليقات",
  failed_retrieve_feedback: "فشل استرجاع التعليقات!",
  province: "المحافظة",
  search_city_placeholder: "ابحث عن اسم المدينة اللي تبيها.",
  search_city_label: "بحث المدينة",
  welcome: "أهلًا وسهلًا بتطبيقنا",
  description: "هذا تطبيق متعدد اللغات.",
  soon: "قريبًا",
  beta_version: "نسخة تجريبية",
  defaults_cleared_success: "البيانات الافتراضية اتحذفت بنجاح",
  defaults_reset_success: "البيانات الافتراضية رجعت بنجاح",
  select_navigator_after_location_click:
    "بعد ما تضغط على الموقع، اختار المُنقِّذ (النافيجيتور) اللي تبيه",
  no_address_selected: "ما مختار عنوان",
  no_location_selected: "ما مختار موقع",
  region: "المنطقة",
  api_unauthorized: "خطأ في التحقق: مفتاح الـ API مو صحيح",
  location_not_found: "الموقع ما لكاه",
  addCategory: "إضافة تصنيف جديد",
  editCategory: "تعديل التصنيف",
  deleteCategory: "إزالة التصنيف المختار؟",
  addProduct: "إضافة منتج جديد",
  saveProducts: "اختار المنتجات الافتراضية",
  addSubCategory: "إضافة تصنيف فرعي",
  product: "المنتج",
  categoryName: "اسم التصنيف",
  subCategoryName: "اسم التصنيف الفرعي",
  confirmDeleteProduct: "متأكد تحذف المنتج من التصنيف؟",
  successMessages: {
    categorySaved: "التصنيفات اتحفظت بنجاح.",
    productSaved: "المنتجات اتحفظت بنجاح.",
    productDeleted: "المنتج اتحذف بنجاح.",
  },
  errorMessages: {
    saveCategoryFailed: "خطأ بحفظ التصنيفات!",
    saveProductFailed: "خطأ بحفظ المنتجات!",
    deleteCategoryFailed: "خطأ بحذف التصنيف!",
  },
  add_edit_categories: "تعديل/إضافة تصنيف",
  copy_category: "نسخ التصنيف",
  product: "منتج {point}",
  copy_product: "نسخ المنتج",
  add_edit_products: "إضافة/تعديل المنتجات",
  copy_category: "نسخ التصنيف",
  edit_category: "تعديل التصنيف",
  category_name: "اسم التصنيف",
  edit_subcategory: "تعديل التصنيف الفرعي",
  subcategory_name: "اسم التصنيف الفرعي",
  add_new_category: "إضافة تصنيف جديد",
  store_management: "إدارة المتجر",
  manage_products: "إدارة المنتجات",
  products_export: "تحميل المنتجات",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "رفع ملف إكسل",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "اسحب ملف الإكسل مالتك وأفلته هنا أو",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "اختاره",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "للرفع",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "يرجى رفع ملف إكسل (.xlsx) فقط",
  "GENERAL.SUBMIT": "إرسال",
  "GENERAL.CANCEL": "إلغاء",
  "GENERAL.SUCCESSFULLY_ADDED": "المنتجات ارفعت بنجاح",
  SUCCESSFULLY_DOWNLOADED: "المنتجات اتحملت بنجاح",
  "GENERAL.ERROR": "صار خطأ",
  EditSubCategoty: "تعديل التصنيف الفرعي",
  create: "إنشاء",
  save_changes: "حفظ التغييرات",
  buy_button_settings: "إعدادات زر الشراء",
  image: "الصورة",
  color: "اللون",
  title: "العنوان",
  price: "السعر",
  discount: "الخصم",
  percent: "بالنسبة المئوية",
  amount: "المبلغ",
  brand: "الماركة",
  inventory: "عدد المخزون",
  inventory_hint: "إذا الحقل فاضي، يعني طلب غير محدود",
  order_limit: "أقصى عدد في كل طلب",
  order_limit_hint: "إذا الحقل فاضي، يعني بدون حد.",
  packing_price: "تكلفة التغليف",
  packing_price_hint:
    "إذا العميل اختار طلب خارجي (توصيل بالكوريير/استلام حضوري)، تُطبق.",
  description: "الوصف",
  options: "الخيارات",
  product_features: "مميزات المنتج",
  field_required: "الحقل مطلوب.",
  min_length: "أقل طول للحقل ٣ أحرف.",
  product: "المنتج",
  default_brand: "آبل",
  product_added_success: "المنتج انضاف بنجاح",
  product_added_error: "خطأ بإضافة المنتج",
  whole_categories: "(كل التصنيفات)",
  add_select_category: "إضافة/اختيار تصنيف",
  select_default_category: "اختيار التصنيف الافتراضي",
  deleted_product: "حذف المنتج",
  confirm_delete_prooduct: "متأكد تحذف المنتج من التصنيف؟",
  please_wait_store_product: "جاري حفظ المنتجات، انتظر شوية...",
  saved_product_success: "المنتجات اتحفظت بنجاح.",
  error_in_store: "خطأ بالحفظ",
  delete_category: "حذف التصنيف",
  confirm_delete_category: "التصنيف اتحذف بنجاح.",
  error_delete_category: "خطأ بحذف التصنيف!",
  productOptionEditor: {
    tabs: {
      color: "اللون",
      size: "المقاس",
      count: "العدد",
      weight: "الوزن",
      type: "النوع/الجنس",
    },
    fields: {
      count: "العد »",
      max_order: "أقصى عدد طلب",
      price: "السعر",
      discount: "الخصم",
      color: "اللون",
      color_name: "اسم اللون",
      inventory: "عدد المخزون",
      size: "المقاس",
      type: "النوع/الجنس",
      weight: "الوزن",
    },
    actions: {
      delete: "حذف",
      add_location: "إضافة خيار",
    },
  },
  extraSubProducts: {
    feature: "الميزة",
    name_label: "الاسم",
    name_placeholder: "مثال: صلصة إضافية/خبز إضافي",
    price_label: "السعر",
    price_hint: "إذا الحقل فاضي، يعني المنتج الفرعي مجاني.",
    price_placeholder: "مثال: ماء، نوع (مثل نوع الدجاج المطبوخ: صدر/فخذ)",
    add_subproduct: "إضافة منتج فرعي",
  },
  error_selected_category: "خطأ باختيار التصنيف!",
  suggestinput: {
    title: "اختيار إيموجي",
    aboutUs: "عنا",
    error: "خطأ",
    errorMessage: "يرجى شحن المحفظة وجرب مرة ثانية.",
    generateText: "اقتراح الذكاء الاصطناعي",
    emoji: "إيموجي",
    errorMessage_400: "صار مشكلة بإنشاء نص 'عنا'. جرب مرة ثانية.",
    errorMessage_403: "صار مشكلة بإنشاء نص 'عنا'، اشترِ باقة وجرب مرة ثانية",
  },
  togetherai: {
    buy_package: "شراء باقة",
    tax_notice: "يضاف ١٠٪ ضريبة على مبلغ الباقة المشتراة!",
    package: "الباقة",
    rial: "ريال",
    buy_button: "أشتري!",
    discount_label: "كود الخصم",
    submit_discount: "تسجيل",
    success_message: "الـ QR مالتك ارتقى بنجاح.",
    error_insufficient_funds: "راجع رصيد حسابك وجرب بعدين.",
    error_upgrade: "خطأ بتجديد الـ QR!",
    error_title: "خطأ",
    success_title: "نجاح",
  },
  category_not_found: "التصنيف ما لكاه!",
  create_upload_category: "إنشاء تصنيف ورفع",
  add_subcategory: "إضافة تصنيف فرعي",
  error_upload_m_video: "خطأ برفع الفيديو (يمكن الوصول محدود).",
  info_show_video: "للمشاهدة أكثر، اضغط على 'المزيد'.",
  error_not_valid_guide_id: "معرف الدليل مو صحيح!",
  error_give_guide_info: "خطأ بجلب معلومات التعليمات!",
  info_success_saved: "اتحفظ بنجاح",
  error_add_new_guide: "خطأ بإضافة دليل جديد",
  popup: {
    details: "التفاصيل",
    guide_images: "صور الدليل",
    guide_videos: "فيديوهات الدليل",
    faq: "الأسئلة الشائعة",
    no_title: "بدون عنوان",
    no_content: "ماكو محتوى للعرض",
    no_questions: "ماكو سؤال للعرض",
    video_error: "خطأ برفع الفيديو (يمكن الوصول محدود)",
    no_answer: "ماكو إجابة",
    question_no_title: "سؤال بدون عنوان",
    default_title: "الدليل",
  },
  productPicker: {
    select_default_product: "اختيار المنتج الافتراضي",
    search: "بحث",
    select_all_products: "اختيار كل المنتجات",
    back: "رجوع",
    no_products_in_category: "ماكو منتج بهذا التصنيف!",
    products_error: "خطأ بجلب المنتجات!",
    retry: "جرب مرة ثانية",
    items_per_page: "عدد العرض",
    root_breadcrumb: "/",
  },
  end_date: "تاريخ الانتهاء",
  filters: {
    userType: {
      legal: "قانوني",
      individual: "فردي",
    },
    serviceType: {
      Payamakland: "رسائل لاند",
      Coreland: "كور لاند",
      Qrland: "كيو آر لاند",
      Robotland: "روبوت لاند",
      billboard: "لوحة إعلانات",
      tablighNegar: "تبليغ نگار",
      unknown: "غير معروف",
    },
    qrType: {
      attendanceqr: "تسجيل الحضور والغياب",
      gift: "إطار الذكريات",
      instagram: "إنستغرام",
      visitCard: "بطاقة عمل",
      Business: "شخصي / للشركات",
      Commericial: "موقع المجمع التجاري / الإداري",
      qrlink: "رابط QR",
      labelproduct: "ملصق المنتج",
      goldLabel: "ملصق الذهب",
      bShop: "المتجر",
      SocialMedia: "مواقع التواصل الاجتماعي",
      VideoGallery: "معرض الفيديو",
      PhotoGallery: "معرض الصور",
      voiceGallery: "معرض الصوت",
      consultationQr: "استمارة الطلب",
      application: "تطبيق",
      feedbackGallery: "آراء وملاحظات المستخدمين",
      voiceGalleryPro: "معرض الصوت الاحترافي",
      singleProduct: "التعريف بالمنتج",
      menu: "القائمة",
      appointment: "حجز موعد",
      insurance: "التأمين",
      text: "نص",
      luck_wheel: "عجلة الحظ",
      pdfgallery: "معرض ملفات PDF",
      productpro: "التعريف بالمنتج Pro",
      multicard: "بطاقات متعددة",
      catalog: "الكتالوج",
      visitCard_pro: "بطاقة عمل Pro",
      clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "يوم",
      expired: "منتهي",
    },
    numericPersianNumber: {
      thousand: "ألف",
      million: "مليون",
    },
    dateString: {
      at: "في",
    },
    messages: {
      pleaseLogin: "تفضل سجل دخول",
      invalidPhone: "رقم الهاتف مو صحيح",
      copied: "انسخ",
    },
  },
  nextButton: "التالي",
  previousButton: "السابق",
  rowsPerPageText: "عدد في الصفحة",
  noDataText: "ماكو بيانات للعرض",
  placeholderSearch: "ابحث..",
  set_qr: "QR مسجل",
  numbers: "الأرقام",
  enter_param_product: "أدخل مواصفات المنتجات صحيح!",
  instagram_hint: "أدخل إنستاگرامك",
  whatsapp_hint: "أدخل واتسابك",
  telegram: "تليگرام",
  telegram_hint: "أدخل تليگرامك",
  userpicker: {
    select_user: "اختيار المستخدم",
    choice_users: "اختيار المستخدمين",
    id: "المعرف",
    phone_number: "رقم الجوال",
    date_created: "تاريخ التسجيل",
    info_edit: "تعديل المعلومات",
    name_family: "الاسم والعائلة",
    position: "المنصب والرتبة",
    phone: "رقم الاتصال",
    discription: "الوصف",
  },
  search_product: "بحث عن منتج",
  search_name_product: "ابحث اسم المنتج",
  search_name_product: "بحث اسم المنتج",
  search_product: "بحث المنتج",
  currency: "ريال",
  headers: {
    index: "الترتيب",
    gallery: "الصورة",
    id: "المعرف",
    name: "الاسم",
    brand: "الماركة",
    price: "المبلغ",
    discount_amount: "الخصم",
  },
  search_categories: "بحث في التصنيفات",
  search_categories: "بحث ",
  delete_all: "حذف الكل",
  select_category: "اختيار التصنيف",
  currency1: "ريال إيراني", // وحدة العملة الإيرانية (الريال)
  features: "المميزات",
  product_sp: {
    edit: "تعديل",
    back: "رجوع",
    save: "حفظ",
    add_product_to_special_category:
      "أكمل الحقول اللي جوا لإضافة المنتج للتصنيف الخاص",
    inventory: "المخزون",
    discount: "الخصم",
    max_per_customer: "أقصى عدد لكل زبون",
    max_per_order: "أقصى عدد في كل سلة",
    expires_at: "تاريخ الانتهاء",
    field_cannot_be_empty: "الحقل ما يصير فاضي.",
    please_enter_correctly: "أدخل الحقول صحيح!",
    currency: "ريال إيراني", // وحدة العملة الإيرانية (الريال)
  },
  selectproduct: "اختيار المنتج",
  section: {
    edit_part: "تعديل القسم",
    title: "العنوان",
    position_text: "موقع النص",
    add_video: "إضافة فيديو",
    text: "النص",
    address_video: "عنوان الفيديو",
    position_left: "موقع يسار",
    position_right: "موقع يمين",
    tab_edit_button: "تعديل الزر",
    tab_content: "محتوى القسم",
  },
  name_shopping: "اسم المتجر",
  hint_shopping: "أدخل اسم متجرك.",
  title_discount: "عنوان الخصم",
  hint_discount: "أدخل عنوان الخصم مالتك.",
  hint_mount_discount: " ٢٠٪ خصم على طلبك القادم.",
  label_discount: "أدخل مقدار الخصم",
  give_discount: "أخذ كود خصم",
  give_copon: "خذ كوبون",
  enter_copon: "إدخال الكوبون",
  hint_phone: "أدخل رقم تلفونك.",
  label_phone: "رقم التلفون",
  hint_condition_discount: "اشرح شروط الخصم..",
  label_discription_discount: "وصف الخصم",
  add_info_discount: "أضف معلومات إضافية تريدها:",
  enter_address_discount: "أدخل عنوانك.",
  address_discount: "العنوان",
  edit_feedback: "تعديل التعليق",
  select_type_replay: "اختيار نوع الرد",
  field_discription: "حقل الوصف",
  messages_discription: "بتفعيل هالخيار، يظهر حقل وصف للمستخدم",
  number_char: "عدد الأحرف لازم يكون بين ٣ و٥٠!",
  search: "بحث",
  no_videos_found: "ما لكينا فيديو!",
  upload_video_prompt: "لإضافة ملف، استخدم قسم رفع الفيديو",
  delete_success: "اتحذف بنجاح.",
  tabs: {
    qr_view: "عرض الـ QR",
    preview: "معاينة",
    ready_video: "فيديو جاهز",
    video_gallery: "معرض فيديو",
    link: "الرابط",
    video_upload: "رفع فيديو",
  },
  consultation: {
    name: "الاسم",
    surname: "اللقب",
    phone: "رقم الجوال",
    nationalId: "الرقم الوطني",
    nationalIdAuthenticate: "التحقق من الرقم الوطني",
    nationalIdCorrect: "فحص صحة الرقم الوطني",
    mail: "البريد",
    address: "العنوان",
    location: "الموقع",
    custom: "قابل للتخصيص",
    customLabel: "العنوان",
    customOptions: "الخيارات",
    optional: "اختياري",
    require: "إلزامي",
    description: "الوصف",
  },
  add_section: "إضافة قسم",
  add_new_text_section: "انتم مدعوون إلى أرض كيو آر لاند الذكية الرقمية.",
  btn_title_section: "تسجيل مجاني",
  shop: {
    step_products_and_info: "المنتجات والمعلومات",
    online_store_name: "اسم المتجر الإلكتروني",
    qr_address: "عنوان الـ QR",
    qr_address_hint: "أدخل عنوان الـ QR مالتك",
    online_sale: "بيع إلكتروني",
    step_content_settings: "إعدادات المحتوى",
    step_sale_settings: "إعدادات البيع",
    download_qr: "تحميل الـ QR",
    login_settings: "إعدادات الدخول",
    store_logo_images: "شعار وصور المتجر",
    login_page_info: "معلومات صفحة الدخول",
    upload_banner: "رفع بانر",
    user_info: "معلومات المستخدم",
    create_product: "إنشاء منتج",
    special_sale: "بيع خاص",
    add_social_media: "إضافة شبكات تواصل",
    blog: "مدونة",
    services: "خدمات",
    faq: "أسئلة شائعة",
    photo_gallery: "معرض صور",
    video_gallery: "معرض فيديو",
    pdf_gallery: "معرض PDF",
    feedback: "تعليق",
    countdown: "عد تنازلي",
    request_form: "نموذج طلب",
    create_section: "إنشاء قسم",
    achievements: "الإنجازات",
    team_members: "أعضاء الفريق",
    working_hours: "ساعات العمل",
    error_saving_content: "خطأ بحفظ إعدادات المحتوى!",
    success_edit_store: "صفحة المتجر تعدلت بنجاح.",
    post_1: "منشور ١",
    logo: "الشعار",
    background_image: "صورة الخلفية",
  },
  discount_obj: {
    quantity: "الكمية", 
    create_edit_code: "إنشاء/تعديل كود خصم",
    coding_type_label: "نوع الإنشاء",
    coding_type_single: "منفرد",
    coding_type_group: "جماعي",
    status_label: "الحالة",
    status_active: "نشط",
    status_deactivate: "معطل",
    discount_code: "كود الخصم",
    discount_type: "نوع الخصم",
    discount_type_percent: "نسبة مئوية",
    discount_type_fixed: "مبلغ ثابت",
    discount_value: "قيمة الخصم",
    discount_limit: "حد الخصم",
    no_limit: "بدون حد",
    tab_create_discount: "إنشاء كود خصم",
    tab_settings: "الإعدادات",
    success_create: "كود الخصم انشأ بنجاح",
    success_edit: "كود الخصم تعدّل بنجاح",
    error_value_empty: "قيمة الخصم ما تصير فاضية!",
    error_start_time: "ما اخترت وقت بدء العرض!",
    error_end_time: "ما اخترت وقت انتهاء العرض!",
    error_same_time: "وقت البدء والانتهاء ما يصير نفس الشي",
  },
  personnel: {
    team_members: "أعضاء الفريق المختارين",
    add_team_member: "إضافة عضو فريق",
    default_position: "المنصب والرتبة",
    default_phone: "رقم الاتصال",
    default_full_name: "الاسم الكامل",
    default_description:
      "لوريم إيبسوم نص وهمي بسيط من صناعة الطباعة واستخدمه المصممون",
  },
  discount_settings: {
    function_type: {
      title: "نوع عمل الخصم",
      all_shopping_cart: "كل مبلغ السلة",
      special_products: "منتجات خاصة",
      special_categories: "تصنيفات خاصة",
    },
    basket_condition: {
      title: "شروط السلة",
      no_conditions: "بدون شروط",
      minimum_shopping: "أدنى مبلغ في السلة",
      minimum_product: "أدنى عدد منتجات في السلة",
      maximum_shopping: "أقصى مبلغ في السلة",
      maximum_product: "أقصى عدد منتجات في السلة",
    },
    user_settings: {
      title: "إعدادات المستخدمين",
      all_user: "كل المستخدمين",
      group: "مجموعة من المستخدمين",
      special: "مستخدمين خاصين",
    },
    limitation_use: {
      title: "حد الاستخدام",
      no_limitations: "بدون حدود",
      discount_code: "عدد استخدام كود الخصم",
      user: "عدد استخدام لكل مستخدم",
    },
    start_time: {
      title: "تاريخ بدء الخصم",
      no_time_selected: "ما اخترت وقت بدء",
    },
    end_time: {
      title: "تاريخ انتهاء الخصم",
      no_time_selected: "ما اخترت وقت انتهاء",
    },
  },
  counterService: {
    typeLabel: "نوع العرض",
    number: "عدد",
    percent: "نسبة مئوية",
    iconLabel: "أيقونة",
    counterLabel: "القيمة",
    linkLabel: "الرابط",
    nameLabel: "العنوان",
    addButton: "إضافة إنجاز",
    successful: {
      added: "العنصر انضاف بنجاح",
      removed: "العنصر اتحذف بنجاح",
      movedUp: "العنصر انتقل لفوق بنجاح",
      movedDown: "العنصر انتقل لتحت بنجاح",
    },
  },
  qrUsersList: {
    customersList: "قائمة الزبائن",
    orders: "الطلبات",
    addresses: "العناوين",
    hasAssistantsMobile_hint: "اختيار الموبايل",
    invalidPhone: "رقم الموبايل اللي دخلته مو صحيح",
    validation: {
      nameRequired: "ادخال الاسم ضروري",
      nameMinLength: "الاسم لازم يكون على الأقل حرفين",
      familyRequired: "ادخال اسم العائلة ضروري",
      familyMinLength: "اسم العائلة لازم يكون على الأقل حرفين",
    },
    addUser: "إضافة مستخدم",
    registerOnline: "تفعيل التسجيل أونلاين",
    usersColumns: {
      id: "المعرف",
      name: "الاسم",
      family: "اللقب",
      mobile: "رقم الجوال",
      subscriptionId: "رقم الاشتراك",
      ordersCount: "عدد الطلبات",
      lastLogin: "آخر دخول",
      status: "الحالة",
      activeUser: "مستخدم نشط",
      none: "-",
      actions: "الإجراءات",
      buttons: {
        info: "معلومات الزبون",
        sendSms: "إرسال رسالة",
        history: "السجل",
        addresses: "العناوين",
        orders: "الطلبات",
      },
    },
    orderColumns: {
      orderId: "رقم الطلب",
      customerName: "اسم الزبون",
      mobile: "رقم الجوال",
      paymentMethod: "طريقة الدفع",
      shippingMethod: "طريقة الاستلام",
      orderAmount: "مبلغ الطلب",
      orderTime: "وقت الطلب",
      status: "الحالة",
      currency: "ريال",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "عنوان العنوان",
      name: "الاسم",
      family: "اللقب",
      mobile: "رقم الاتصال",
      address: "العنوان",
      zipCode: "الرمز البريدي",
      number: "رقم البناية",
      unit: "الوحدة",
    },
    shippingType: {
      courier: "توصيل بالكوريير",
      reservation: "حجز طاولة",
      place: "استلام حضوري",
      none: "-",
    },
    paymentType: {
      online: "دفع إلكتروني",
    },
    perPage: "عدد في الصفحة",
    search: "بحث",
    sortColumn: "ترتيب حسب",
    sortDirection: "اتجاه الترتيب",
    sortDirectionDesc: "تنازلي",
    sortDirectionAsc: "تصاعدي",
    noStatus: "ما لكينا حالة",
    status: {
      all: "الكل",
      active: "نشط",
      inactive: "معطل",
    },
    fetchError: "خطأ بجلب بيانات المستخدمين",
  },
  listCardHeader: {
    clear_filters: "إزالة الفلاتر",
    group_qr_renewal: "تجديد جماعي للـ QR",
    select_desired_duration: "اختار المدة اللي تريدها",
    total_count: "العدد الكلي",
    final_amount: "المبلغ النهائي",
    ten_percent_vat_will_be_added: "يضاف ١٠٪ ضريبة القيمة المضافة",
    pay_and_upgrade: "ادفع وارتقِ",
    no_tariff_for_this_period: "ماكو تعرفة لهذي الفترة",
    one_month_renewal: "تجديد شهري",
    three_month_renewal: "تجديد ثلاثة أشهر",
    six_month_renewal: "تجديد ستة أشهر",
    one_year_renewal: "تجديد سنوي",
    selected: "مختار",
    view: "عرض",
    details: "التفاصيل",
    total_amount: "المبلغ الكلي",
    discount: "الخصم",
    final_amount_with_discount: "المبلغ النهائي مع الخصم",
    add_qr: "إضافة QR",
    select_all: "اختيار الكل",
    actions: "الإجراءات",
    filter: "فلتر",
    type_filter: "فلتر النوع",
    start_from: "يبدأ من",
    search: "بحث",
    id_search: "بحث في المعرف",
    filter_user: "فلتر المستخدم",
    sort: "ترتيب",
    send_sms: "إرسال رسالة",
    selected_pattern: "النمط المختار:",
    send: "إرسال",
    newest: "الأحدث",
    oldest: "الأقدم",
    most_visited: "الأكثر زيارة",
    least_visited: "الأقل زيارة",
    pause: "إيقاف",
    bulk_download: "تحميل جماعي",
    activate: "تفعيل",
    deactivate: "إيقاف",
    error_loading_card: "خطأ بتحميل بيانات البطاقة!",
    error_fetching_prices: "خطأ بجلب الأسعار!",
    error_payment: "خطأ بالدفع!",
    sms_success: "الإرسال سجل بنجاح",
    generic_error: "صار خطأ!",
  },
  headerTypeFilter: {
    qr_model: "موديل الـ QR",
    all_qr_models: "كل موديلات الـ QR",
  },
  menuOrderFactor: {
    order_invoice: "فاتورة الطلب",
    total: "المجموع",
    tax: "الضريبة",
    shipping_cost: "تكلفة الشحن",
    packing_cost: "تكلفة التغليف",
    discount: "الخصم",
    final_total: "المجموع النهائي",
    currency: "ريال",
    titles: {
      default_title: "طلب افتراضي",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "بحث في القائمة",
    search: "بحث",
    start_from: "يبدأ من",
  },
  headerStatusFilter: {
    all_qr_codes: "كل أكواد الـ QR",
    active_qr_codes: "أكواد الـ QR النشطة",
    inactive_qr_codes: "أكواد الـ QR المعطلة",
    expiring_qr_codes: "أكواد الـ QR اللي راح تنتهي",
    expired_qr_codes: "أكواد الـ QR المنتهية",
  },
  qrOrdersList: {
    title: "قائمة الطلبات",
    orderColumns: {
      index: "الترتيب",
      id: "رقم الطلب",
      customerName: "اسم الزبون",
      mobile: "رقم الجوال",
      paymentType: "طريقة الدفع",
      shippingType: "طريقة الاستلام",
      price: "مبلغ الطلب",
      createdAt: "وقت الطلب",
      status: "الحالة",
      actions: "الإجراءات",
    },
    productsColumns: {
      productId: "معرف المنتج",
      image: "الصورة",
      productName: "اسم المنتج",
      unitPrice: "سعر الوحدة",
      quantity: "العدد",
      totalPrice: "السعر",
    },
    actions: {
      products: "قائمة الطلب",
      print: "طباعة الطلب",
      share: "مشاركة الطلب",
      status: "تغيير الحالة",
    },
    shippingType: {
      courier: "توصيل بالكوريير",
      reservation: "حجز طاولة",
      place: "استلام حضوري",
      post: "إرسال بالبريد",
      unknown: "-",
    },
    paymentType: {
      online: "دفع إلكتروني",
      place: "دفع عند الاستلام",
      unknown: "-",
    card2card: "دفعة بطاقة إلى بطاقة",

    },
    status: {
      all: "الكل",
      pending: "بانتظار الدفع",
      accepted: {
        place: "دفع عند الاستلام",
        paid: "مدفوع",
      },
      delivered: "تم التسليم",
      rejected: "دفع فاشل",
    },
    factorTitle: "فاتورة الطلب",
    printFactor: "طباعة الفاتورة",
    fetchError: "خطأ بجلب البيانات",
    statusChanged: "الحالة تغيرت بنجاح",
    statusChangeError: "خطأ بتغيير الحالة",
    currency: "ريال",
    perPage: "عدد",
    search: "بحث",
    noStatus: "ماكو حالة",
    loading: "جاري التحميل...",
    noShippingType: "ماكو نوع شحن",
    noPaymentType: "ماكو نوع دفع",
    sortColumn: "عمود الترتيب",
    sortDirection: "اتجاه الترتيب",
    sortDirectionDesc: "تنازلي",
    sortDirectionAsc: "تصاعدي",
    selectNewStatus: "اختيار حالة جديدة",
    changeStatusTitle: "تغيير الحالة",
    linkCopied: "الرابط انسخ.",
  },
  qrUserTransfer: {
    title: "نقل الملكية",
    radioLabels: {
      userTransfer: "نقل لشخص آخر",
      givingAccess: "منح الوصول",
    },
    inputLabels: {
      phone: "رقم جوال الشخص",
    },
    hints: {
      addNumber: "لتحديد الوصول، اضغط Enter أو أيقونة +",
      addNumberStep2: "لإضافة الرقم، اضغط Enter أو أيقونة +",
    },
    buttons: {
      transfer: "نقل",
      giveAccess: "منح الوصول",
      back: "رجوع",
      saveChanges: "حفظ التغييرات",
      cancel: "إلغاء",
        "add": "ضيف"

    },
    tooltips: {
      deleteAccess: "حذف الوصول",
    },
    subtitles: {
      accessList: "قائمة من لديهم وصول:",
      selectPermissions: "اختيار الصلاحيات:",
    },
    permissionList: {
      edit_name: "تعديل اسم الخدمة",
      edit_link: "تعديل الرابط",
      edit_info: "تعديل المعلومات",
      edit_design: "تعديل تصميم كود الـ QR",
      edit_settings: "تعديل إعدادات كود الـ QR",
      toggle_access: "تفعيل/إيقاف الوصول",
      view_customers: "عرض قائمة الزبائن",
      view_orders: "عرض قائمة الطلبات",
    },
    messages: {
      invalidPhone: "الرقم المدخل مو صحيح",
      duplicatePhone: "ما تقدر تدخل رقم مكرر",
      updateAccessSuccess: "الوصولات تحدثت بنجاح.",
      updateAccessError: "خطأ بتحديث الوصول: {message}",
      deleteAccessSuccess: "الوصول انقطع بنجاح.",
      deleteAccessError: "خطأ بقطع الوصول: {message}",
      fetchAccessError: "خطأ بقراءة الوصولات: {message}",
      transferSuccess: "الـ QR انتقل بنجاح.",
      transferError: "خطأ بنقل الـ QR: {message}",
      giveAccessSuccess: "تم بنجاح.",
      giveAccessError: "خطأ بإعداد الوصول: {message}",
      confirmDeleteAccess: "متأكد تقطع وصول هذا الشخص؟",
    },
  },
  form: {
    form_download: "النماذج المستلمة",
    form_add: "إضافة نموذج",
    formdownload: "نموذج مستلم",
    create_at: "أنشئ في :",
    shown: "عرض",
    nogiveform: "ما عندك نموذج مستلم",
    back: "رجوع",
    invalid_date: "تاريخ غير صحيح",
    select_date: "اختيار تاريخ",
    select: "اختيار",
    clear: "إلغاء",
    now: "الآن",
  },
  dsBasketCondition: {
    title: "أدنى شروط السلة",
    items: {
      NoConditions: "بدون شروط",
      MinimumShopping: "أدنى مبلغ في السلة",
      MinimumProduct: "أدنى عدد منتجات في السلة",
      MaximumShopping: "أقصى مبلغ في السلة",
      MaximumProduct: "أقصى عدد منتجات في السلة",
    },
  },
  dsUserSettings: {
    title: "أدنى شروط السلة",
    groupTitle: "المستخدمين اللي",
    specialTitle: "المستخدم",
    labels: {
      minimumCart: "أدنى شروط السلة",
      users: "المستخدمين",
    },
    items: {
      AllUser: "كل المستخدمين",
      group: "مجموعة من المستخدمين",
      special: "مستخدمين خاصين",
    },
    groupItems: {
      Order: "المستخدمين اللي اشتروا قبل",
      noOrder: "المستخدمين اللي ما اشتروا قبل",
    },
  },
  qrAddressUpdate: {
  title: "تعديل العنوان",
  labels: {
    address: "عنوان QR",
  },
  hints: {
    allowedChars: "مسموح فقط بالحروف الإنكليزية والأرقام والشرطة (-) والشرطة السفلية (_)",
  },
  buttons: {
    removeInvalidChars: "حذف الأحرف غير المسموح بها",
  },
  errors: {
    minLength: "يجب إدخال 3 أحرف على الأقل",
    invalidChars: "حرف غير صالح! استخدم فقط الحروف الإنكليزية والأرقام و- و_.",
    invalidAddress: "العنوان المُدخل غير صالح",
    updateFailed: "حدث خطأ أثناء تحديث العنوان",
  },
  successMessage: "تم تحديث العنوان بنجاح",
  warning: "تنبيه",
  warningMessage: "تغيير العنوان راح يسبب توقف الروابط السابقة عن العمل.",
  savePrompt: "متأكد تريد حفظ هذا التغيير؟",
},
  dsFunctionType: {
    title: "الخصم يطبق على",
    productListTitle: "قائمة المنتجات",
    categoryListTitle: "قائمة التصنيفات",
    labels: {
      applyDiscount: "تطبيق الخصم على",
      category: "التصنيف",
    },
    items: {
      AllShoppingCart: "كل مبلغ السلة",
      SpecialProducts: "منتجات خاصة",
      SpecialCategories: "تصنيفات خاصة",
    },
  },
  dsLimitationUse: {
    title: "حد الاستخدام",
    discountCodeTitle: "عدد الاستخدام",
    userTitle: "عدد المستخدم",
    labels: {
      limitation: "الحد",
      usage: "الاستخدام",
      user: "المستخدم",
    },
    items: {
      NoLimitations: "بدون حدود",
      DiscountCode: "عدد استخدام كود الخصم",
      User: "عدد استخدام لكل مستخدم",
    },
  },
  ManageHourLimitQr: {
    noLimit: "بدون حد",
    dateLimit: "حد تاريخ",
    timeLimit: "حد ساعة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    selectDate: "اختيار تاريخ",
    startTime: "ساعة البدء",
    endTime: "ساعة الانتهاء",
  },
  discount_percent_range: "الخصم لازم يكون بين ٠ و١٠٠ بالمية",
  discount_price_range: "الخصم لازم يكون بين ٠ و{max}",
  invalid_number: "أدخل أرقام فقط",
  min_order_cart: "أدنى سلة طلب",
  preparation_time: "مدة التحضير (دقيقة)",
  delivery_time: "مدة التوصيل (دقيقة)",
  max_product_in_order: "أقصى عدد منتج في كل طلب",
  max_order_by_person: "أقصى عدد طلب لكل زبون",
  send_by_courier_price: "تكلفة الكوريير",
  vat: "نسبة الضريبة",
  send_by_post: "تكلفة البريد",
  online_pay: "دفع إلكتروني",
  pay_in_person_place: "دفع عند الاستلام",
  in_place: "استلام حضوري",
  table_booking_ability: "حجز طاولة",
  send_by_courier: "توصيل بالكوريير",
  vat_switch: "الضريبة",
  invalid_number: "أدخل أرقام فقط",
  positive_number: "الرقم لازم يكون موجب",
  vat_range: "الضريبة لازم تكون بين ٠ و١٠٠ بالمية",
  sort_column: "عمود الترتيب",
  direction_sort: "اتجاه الترتيب",
  listFeedbackUser: {
    no_questions: "ما عندك أسئلة لجمع التعليقات",
    add_feedback_prompt: "لإضافة تعليق جديد، روح لتبويب الإضافة",
    question_label: "السؤال",
    show_answers: "عرض الإجابات",
    back_button: "رجوع",
    no_feedback: "ما عندك تعليق!",
    user_opinion: "رأي المستخدم",
    score_label: "التقييم",
  },
  manageDiscount: {
    createNewDiscount: "إنشاء كود خصم جديد",
    copy: "نسخ",
    row: "الصف",
    id: "المعرف",
    discountCode: "كود الخصم",
    usageLimit: "سقف الاستخدام",
    used: "مستخدم",
    manage: "إدارة",
    edit: "تعديل",
    delete: "حذف",
    sendSms: "إرسال رسالة للجمهور",
    copySuccess: "كود الخصم انسخ",
    copyError: "صار مشكلة",
    deleteSuccess: "كود الخصم اتحذف",
    deleteError: "خطأ بحذف كود الخصم",
    smsSuccess: "كود الخصم ارسل للجمهور",
    smsError: "صار مشكلة",
  },
  manageTableReservation: {
    table: "الطاولة",
    number: "رقم {num}",
    add_table: "إضافة طاولة",
    complete_info_for_customer: "أكمل المعلومات اللي جوا لعرضها للزبون",
    select_image: "اختيار صورة",
    table_name_number: "اسم/رقم الطاولة",
    number_of_seats: "عدد كراسي الطاولة",
    type: "النوع",
    reservation_cost: "تكلفة الحجز",
    enter_table_name: "أدخل اسم/رقم الطاولة",
    table_type: "طاولة",
    couch_type: "تخت",
    gazebo_type: "كوخ",
  },
  create_menu: {
    data: {
      visitName_label: "اسم الزيارة",
      organizationName: "فاست فود زنجيري كبير",
      subOrgan: "جرب أفضل طعم فاست فود ويانا",
      aboutUs:
        "فاست فود الكبير، بحفظ الجودة واحترامكم، حاولنا نوفرلكم الأفضل.\nحفظ الجودة من المبادئ اللي ملتزمين بيها.\nبقسم الفاست فود، لحد الآن، ويا الساندويتشات الخاصة، كنا طعم جديد بصف الوجبات السريعة\nاحنا كل يوم جاهزين نخدمكم بمواعيد إدارية، أعياد ميلاد وغيرها...",
      copyright: "كل حقوق هذا الموقع ملك ترمينال الإعلانات.",
      product: {
        title: "المنتجات",
        pizzas: "البيتزات",
        pizza_roast_beef: "بيتزا رست بيف",
        pizza_roast_beef_desc: "🤩بيتزا إيطالية بلحم بقر",
        pizza_roast_beef_ingredients:
          "عجينة بيتزا إيطالية ٣٠ سم، ١٠٠ غرام لحم بقر مفروم، فطر، فلفل دلمة، زيتون أسود",
        pizza_chicken_mushroom: "بيتزا دجاج وفطر",
        pizza_chicken_mushroom_desc: "🍕كلاسيك ٤٠ سم",
        pizza_chicken_mushroom_ingredients:
          "صلصة طماطم طازجة بيتزارا، جبن (مطهر)، فيليه دجاج، فطر، زعتر جبلي",
        pizza_meat_mushroom: "بيتزا لحم وفطر",
        pizza_meat_mushroom_desc: "🥰 بيتزا لحم مفروم مع فطر",
        pizza_meat_mushroom_ingredients:
          "صلصة طماطم طازجة بيتزارا، جبن (مطهر)، لحم فخذ بقر مفروم، فطر، زعتر جبلي، لشخصين (٢٩ سم) ٣٥٥,٠٠٠ تومان، لشخص واحد (٢٢ سم) ٢١٦,٠٠٠ تومان",
        pizza_veggie: "بيتزا خضار",
        pizza_veggie_desc: "🍕 بيتزا خضار أمريكية",
        pizza_veggie_ingredients:
          "عجينة بيتزا أمريكية، ذرة، فطر، زيتون، طماطم، بصل، فلفل، جبن بيتزا",
        pizza_special: "بيتزا خاصة",
        pizza_special_desc: "بيتزا خاصة أمريكية",
        pizza_special_ingredients:
          "عجينة بيتزا أمريكية، لحم بقر مفروم متبل، مزيج هامبورغر لحم ودجاج ٨٠%، جبن موزاريلا مزيج، صلصة خاصة، فلفل دلمة، فطر، بدون صلصة لشخص واحد",
        pizza_bolognese: "بيتزا بولونيز",
        pizza_bolognese_desc: "(لشخص واحد) عجينة بيتزا ٢٣ سم 🤌",
        pizza_bolognese_ingredients:
          "لحم بقر مفروم، جبن موزاريلا، فطر، فلفل دلمة، ذرة، زيتون أسود مقطع",
        pizza_pepperoni: "بيتزا بيبروني",
        pizza_pepperoni_desc: "(لشخص واحد) عجينة بيتزا ٢٣ سم",
        pizza_pepperoni_ingredients:
          "عجينة بيتزا إيطالية، بيبروني ٨٠%، صلصة مارينارا، جبن بيتزا خاص",
        pizza_bacon: "بيتزا بيكون",
        pizza_bacon_desc: "(لشخص واحد) عجينة بيتزا ٢٣ سم 💥",
        pizza_bacon_ingredients:
          "عجينة بيتزا إيطالية، صلصة مارينارا، جبن بيتزا خاص، بيكون مزيج لحم ودجاج ٩٠%، فطر، زيتون، فلفل دلمة",
        pizza_mixed: "بيتزا مشكلة",
        pizza_mixed_desc: "(لشخص واحد) عجينة بيتزا ٢٣ سم 🤭",
        pizza_mixed_ingredients:
          "مزيج هامبورغر لحم ودجاج مفروم، سالامي، لحم بقر مفروم، فطر، زيتون، فلفل دلمة، جبن بيتزا، صلصة خاصة",
        pizza_american_steak: "بيتزا ستيك أمريكية",
        pizza_american_steak_desc: "(لشخص واحد) ٢٣ سم 💥",
        pizza_american_steak_ingredients:
          "عجينة بيتزا أمريكية، لحم بقر قطع، فطر، جبن بيتزا، سمسم",
        burgers: "الهامبرغر",
        cheeseburger: "تشيز برغر",
        cheeseburger_desc: "🤩مع بطاطس مقلية",
        cheeseburger_ingredients:
          "٢ قطع برغر لحم بقر ١٥٠ غرام، صلصة خاصة، جبن غودا، خيار مخلل، خس، طماطم",
        hamburger: "هامبرغر",
        hamburger_desc: "😍لحم خالص مع صلصة خاصة",
        hamburger_ingredients:
          "قطعة برغر لحم بقر ١٥٠ غرام، خيار مخلل، خس، صلصة خاصة، طماطم، خبز ماك، صلصة لشخص واحد",
        chicken_burger: "تشيكن برغر",
        chicken_burger_desc: "دجاج مشوي مع جبن",
        chicken_burger_ingredients:
          "١٥٠ غرام صدر دجاج مشوي، جبن، طماطم، خيار مخلل، خس، خبز ماك، صلصة خاصة",
        spice_burger: "سبايس برغر",
        spice_burger_desc: "لحم بقر مع صلصة سبايسي",
        spice_burger_ingredients:
          "قطعة برغر لحم بقر ١٣٠ غرام، صلصة سبايسي، خس، طماطم، خبز ماك، صلصة سبايسي خاصة",
        double_burger: "دبل برغر",
        double_burger_desc: "لحم بقر ١٥٠ غرام",
        double_burger_ingredients:
          "٢ قطع برغر يدوي لحم بقر ١٥٠ غرام، جبن بيتزا، صلصة كراميل، خس، كرنب، صلصة بيضاء خاصة، خبز دائري",
        royal_burger: "رويال برغر",
        royal_burger_desc: "١٥٠ غرام لحم بقر 🍔",
        royal_burger_ingredients:
          "قطعة برغر يدوي لحم بقر ١٥٠ غرام، جبن بيتزا، ٥ شرائح سالامي، صلصة كراميل، خس، كرنب، صلصة بيضاء خاصة، خبز دائري",
        mushroom_burger: "مشروم برغر",
        mushroom_burger_desc: "لحم بقر ١٥٠ غرام",
        mushroom_burger_ingredients:
          "قطعة برغر يدوي لحم بقر ١٥٠ غرام، فطر، صلصة كراميل، خس، كرنب، صلصة بيضاء خاصة، خبز دائري، جبن موزاريلا",
        mashroom_burger: "ماشروم برغر",
        mashroom_burger_desc: "لحم بقر مشوي ١٠٠%🤩",
        mashroom_burger_ingredients:
          "قطعة برغر يدوي لحم بقر مشوي ١٠٠%، بطاطس مقلية، طماطم، خس، خيار مخلل، صلصة فطر، خبز دائري",
        fried_burger: "برغر مقلي",
        fried_burger_desc: "لحم بقر مشوي مقلي ١٠٠%👌",
        fried_burger_ingredients:
          "قطعة برغر يدوي لحم بقر مشوي مقلي ١٠٠%، ١٥٠ غرام بطاطس مقلية، طماطم، خس، خيار مخلل، صلصة خاصة، خبز دائري",
        fried: "مقلي",
        fried_chicken: "دجاج مقلي",
        fried_chicken_desc: "😍دجاج مقلي ثلاث قطع",
        fried_chicken_ingredients:
          "٣ قطع دجاج مقلي، ١٢٠-١٥٠ غرام بطاطس مقلية، سلطة كرنب ١٠٠-١٢٠ غرام، خبز بروتشن، صلصة خاصة",
        chicken_strips: "تشيكن ستريبس",
        chicken_strips_desc: "٤ قطع فيليه مقلي متبل حار",
        chicken_strips_ingredients:
          "٤ قطع فيليه دجاج مقلي، ١٢٠-١٥٠ غرام بطاطس مقلية، سلطة كرنب ١٠٠-١٢٠ غرام، خبز بروتشن، صلصة تارتار",
        fried_filet: "فيليه مقلي",
        fried_filet_desc: "🤩قطعتين فيليه مقلي مع صلصة خاصة",
        fried_filet_ingredients:
          "قطعتين ستريبس، بطاطس مشوية، سلطة كرنب، خبز بروتشن، صلصة ثوم، صلصة تشيلي تاي، صلصة فلفل",
        fried_mushroom_onion: "فطر وبصل مقلي",
        fried_mushroom_onion_desc: "🤩فطر وبصل مقلي مع صلصة تارتار",
        fried_mushroom_onion_ingredients:
          "٢٠ قطعة فطر مقلي، ٦ قطع بصل مقلي، صلصة تارتار",
        fried_wings: "أجنحة مقلية",
        fried_wings_desc: "٦ قطع أجنحة مقلية 🍗",
        fried_wings_ingredients: "ست قطع أجنحة مشوية مقلية",
        fried_chicken_basket: "سلة دجاج مقلي",
        fried_chicken_basket_desc: "(لشخصين)😍",
        fried_chicken_basket_ingredients:
          "٢ قطع دجاج مقلي، ٢ قطع ستريبس، ٢ قطع بصل حلقي، ٢ قطع جمبري ناگت مقلي، ٢ قطع ناگت دجاج",
        fried_schnitzel: "شنيتسل مقلي",
        fried_schnitzel_desc: "أربع قطع شنيتسل دجاج💥",
        fried_schnitzel_ingredients: "أربع قطع شنيتسل دجاج مقلي مشوي سبايسي",
        veggie_basket_fried: "سلة خضار مقلية",
        veggie_basket_fried_desc: "٢٥٠ غرام🤩",
        veggie_basket_fried_ingredients:
          "٢٥٠ غرام، كوسا مقلي، باذنجان مقلي، فطر مقلي، بطاطس مقلي",
        fried_chicken_2_piece: "دجاج مقلي قطعتين",
        fried_chicken_2_piece_desc: "٢ قطع دجاج مقلي🍗",
        fried_chicken_2_piece_ingredients:
          "١٢٠-١٥٠ غرام بطاطس مقلية، سلطة كرنب ١٠٠-١٢٠ غرام، خبز بروتشن، صلصة خاصة",
        fried_chicken_5_piece: "دجاج مقلي خمس قطع",
        fried_chicken_5_piece_desc: "خمس قطع دجاج مقلي",
        fried_chicken_5_piece_ingredients:
          "١٥٠-٢٠٠ غرام بطاطس مقلية، سلطتان كرنب ١٠٠-١٢٠ غرام، خبزان بروتشن، صلصة خاصة",
        fried_chicken_7_piece: "دجاج مقلي سبع قطع",
        fried_chicken_7_piece_desc: "سبع قطع دجاج مقلي 💥",
        fried_chicken_7_piece_ingredients:
          "١٥٠-٢٠٠ غرام بطاطس مقلية، سلطة كرنب ١٠٠-١٢٠ غرام، ٣ خبزات بروتشن، صلصة خاصة، صلصة لشخص واحد مقلي",
        sandwich: "ساندويتش",
        hotdog_sandwich: "ساندويتش هوت دوگ",
        hotdog_sandwich_desc: "ساندويتش هوت دوگ مع فطر وجبن",
        hotdog_sandwich_ingredients:
          "سجق هوت دوگ مشوي، خس، طماطم، خيار مخلل، فطر وجبن بيتزا",
        roast_beef_sandwich: "ساندويتش رست بيف",
        roast_beef_sandwich_desc: "✔️لحم بقر مفروم",
        roast_beef_sandwich_ingredients:
          "لحم بقر، جبن بيتزا، فطر، شيبس شرائح، خس، طماطم، خيار مخلل، صلصة خاصة، خبز فرنسي",
        ham_sandwich: "ساندويتش هام",
        ham_sandwich_desc: "ساندويتش هام دجاج وفطر (بارد)",
        ham_sandwich_ingredients:
          "هام فطر ودجاج، خس، طماطم، خيار مخلل، شيبس شرائح، صلصة خاصة، خبز باغيت",
        bandari_sausage_sandwich: "ساندويتش بندري",
        bandari_sausage_sandwich_desc: "💥ساندويتش بندري حار",
        bandari_sausage_sandwich_ingredients:
          "أكل بندري مع سجق كوكتيل مدخن ٥٥%، طماطم، خيار مخلل، صلصة خاصة، بصل وكزبرة، خبز بولكي",
        tongue_mushroom_sandwich: "ساندويتش لسان وفطر",
        tongue_mushroom_sandwich_desc: "١٥٠ غرام لسان بقر",
        tongue_mushroom_sandwich_ingredients:
          "فطر، جبن بيتزا مطهر، زيتون، ذرة، خس، خيار مخلل، طماطم، صلصة، مقبلات، بطاطس مقلية، سلطة كرنب",
        falafel_sandwich: "ساندويتش فلافل",
        falafel_sandwich_desc: "ست قطع فلافل🌭",
        falafel_sandwich_ingredients:
          "ست قطع فلافل، خيار مخلل، طماطم، خس، صلصة لشخص واحد، مقبلات، بطاطس مقلية، سلطة كرنب",
        cheesy_kebab_turki_sandwich: "ساندويتش كباب تركي جبني",
        cheesy_kebab_turki_sandwich_desc: "١٥٠ غرام لحم بقر",
        cheesy_kebab_turki_sandwich_ingredients:
          "١٥٠ غرام لحم بقر، جبن بيتزا خاص، خيار مخلل، طماطم، خس، صلصة لشخص واحد، بطاطس مقلية، سلطة كرنب",
        roast_chicken_sandwich: "ساندويتش رست دجاج",
        roast_chicken_sandwich_desc: "شنيتسل دجاج وفطر🤩",
        roast_chicken_sandwich_ingredients:
          "شنيتسل دجاج وفطر، جبن بيتزا خاص، زيتون، ذرة، سمسم، خس، فلفل دلمة، خيار مخلل، طماطم، صلصة خاصة، مقبلات، بطاطس مقلية",
        cheesy_indian_sandwich: "ساندويتش هندي جبني",
        cheesy_indian_sandwich_desc: "سجق ألماني💥",
        cheesy_indian_sandwich_ingredients:
          "سجق ألماني جبني، ذرة، خس، فطر، صلصة خاصة، مقبلات، بطاطس مقلية، سلطة كرنب",
        snack: "سناك",
        chicken_snack: "سناك دجاج",
        chicken_snack_desc: "😋صدر دجاج مفروم",
        chicken_snack_ingredients:
          "١٥٠ غرام صدر دجاج، فلفل دلمة، فطر، خبز سناك خاص، صلصة خاصة",
        meat_snack: "سناك لحم",
        meat_snack_desc: "🥪زوج سناك لحم",
        meat_snack_ingredients:
          "زوج، فخذ بقر مفروم، جبن موزاريلا، ذرة، فلفل دلمة، صلصة خاصة، خبز توست",
        chicken_meat_snack: "سناك تشيكن ميت",
        chicken_meat_snack_desc: "🤩زوج سناك تشيكن ميت",
        chicken_meat_snack_ingredients:
          "زوج، صدر دجاج مفروم، فخذ بقر مفروم، جبن موزاريلا، ذرة، فلفل دلمة، صلصة خاصة، خبز توست",
        special_snack: "سناك خاص",
        special_snack_desc: "🤤 زوج سناك خاص",
        special_snack_ingredients:
          "زوج، مزيج كالاباس لحم ودجاج ٩٠%، جبن موزاريلا، ذرة، فلفل دلمة، صلصة خاصة، خبز توست",
        roast_beef_snack: "سناك رست بيف",
        roast_beef_snack_desc: "لحم بقر مفروم🍖",
        roast_beef_snack_ingredients:
          "لحم بقر مفروم، فطر، جبن بيتزا، فلفل دلمة، ذرة، مقبلات، بطاطس مقلية، سلطة كرنب",
        veggie_snack: "سناك خضار",
        veggie_snack_desc: "سناك خضار ٤ قطع",
        veggie_snack_ingredients:
          "بروكلي، ذرة، زيتون، جبن بيتزا دايت، فطر، مقبلات، بطاطس مقلية، سلطة كرنب",
        chicken_mushroom_snack: "سناك دجاج وفطر",
        chicken_mushroom_snack_desc: "شنيتسل دجاج وفطر👌",
        chicken_mushroom_snack_ingredients:
          "شنيتسل دجاج، فطر، جبن بيتزا خاص، زيتون، ذرة، فلفل دلمة، مقبلات، بطاطس مقلية، سلطة كرنب",
        pepperoni_snack: "سناك بيبروني",
        pepperoni_snack_desc: "كالاباس بيبروني ٩٠%💥",
        pepperoni_snack_ingredients:
          "زوج، كالاباس بيبروني ٩٠%، جبن موزاريلا، ذرة، فلفل دلمة، صلصة خاصة",
        bologna_snack: "سناك بولونيا",
        bologna_snack_desc: "لحم مفروم👌",
        bologna_snack_ingredients:
          "زوج، لحم مفروم، بيكون خاص، فطر مبيض، ذرة، جبن موزاريلا، فلفل دلمة، صلصة خاصة",
        pasta: "باستا",
        alfredo_pasta: "باستا ألفريدو",
        alfredo_pasta_desc: "باستا ألفريدو مع صلصة فطر خاصة",
        alfredo_pasta_ingredients: "٣٥٠ غرام بيني",
        macaroni: "مكرونة",
        macaroni_desc: "🥣مكرونة لحم وفطر",
        macaroni_ingredients:
          "مكرونة شرائط ١.٢، لحم بقر مفروم ١٠٠ غرام، فطر، فلفل دلمة، بطاطس مكعبات مقلية، بازلاء",
        spaghetti_bolognese: "سباغيتي بولونيز",
        spaghetti_bolognese_desc: "🥰باستا لينغويني",
        spaghetti_ingredients:
          "٧٠٠ غرام، باستا لينغويني، لحم بقر وغنم مفروم، صلصة بولونيز، صلصة حمراء رسو خاصة، ملاعق وشوك بلاستيك حسب اختيارك",
        chicken_stroganoff: "تشيكن ستروغانوف",
        chicken_stroganoff_desc: "😍تشيكن ستروغانوف مع صدر دجاج قطع",
        chicken_stroganoff_ingredients:
          "١٨٠ غرام صدر دجاج قطع متبل، كريمة، فطر مبيض، جبن بارميزان، بطاطس مقلية شرائح يدوية، وعاء مايكروويف خاص",
        penne_arrabbiata: "باستا بيني أرابياتا",
        penne_arrabbiata_desc: "صدر دجاج💥",
        penne_arrabbiata_ingredients:
          "لشخص واحد، صدر دجاج، باستا، فطر، جبن بارميزان، طماطم شيري، بقدونس، صلصة أرابياتا",
        chicken_pesto_pasta: "باستا تشيكن بيستو",
        chicken_pesto_pasta_desc: "(لشخص واحد) صدر دجاج",
        chicken_pesto_pasta_ingredients:
          "صدر دجاج، فطر، جبن بارميزان، طماطم شيري، بقدونس، صلصة أرابياتا",
        carbonara_pasta: "باستا كاربونارا",
        carbonara_pasta_desc: "بيكون لحم ٩٧%",
        carbonara_pasta_ingredients:
          "باستا، بيكون لحم ٩٧%، صلصة ألفريدو، جبن بارميزان، طماطم شيري، بقدونس",
        appetizer: "مقبلات",
        hot_chips: "هوت شيبس",
        hot_chips_desc: "😙بأنواع مختلفة من الشيبس",
        hot_chips_ingredients:
          "كيلو شيبس، صلصة خاصة، هام دجاج ٧٠%، فطر، فلفل دلمة، جبن بيتزا، جبن غودا",
        lasagna: "لازانيا",
        lasagna_desc: "لازانيا مع لحم مفروم",
        lasagna_ingredients:
          "٣ شرائح لازانيا، لحم مفروم، فطر، فلفل دلمة، زيتون أسود، جبن بيتزا، صلصة خاصة",
        french_fries: "بطاطس مقلية",
        french_fries_desc: "بطاطس مقلية وياها صلصة خاصة",
        french_fries_ingredients: "150 غرام بطاطس مقلية، صلصة خاصة",
        baked_potato: "بطاطس مشوية",
        baked_potato_desc: "🍟 بطاطس مشوية وياها لحم مقدد بقري",
        baked_potato_ingredients:
          "150 غرام بطاطس مقلية، لحم مقدد بقري 90%، جبنة بيتزا، توابل خاصة، صلصة لشخص واحد",
        garlic_bread: "خبز بالثوم",
        garlic_bread_desc: "صلصة ثوم خاصة💥",
        garlic_bread_ingredients:
          "عجينة بيتزا أمريكية، مزيج جبنة بيتزا، صلصة ثوم خاصة، سمسم",
        silo_potatoes: "بطاطس سيلو",
        silo_potatoes_desc: "بطاطس مقلية لشخصين",
        silo_potatoes_ingredients:
          "بطاطس مقلية بنكهة سيلو، لحم مقدد بقري 97%، صلصة شيدر، آيولي، بصل أخضر، بقدونس",
        bbq_sausage: "سجق مشوي",
        bbq_sausage_desc: "سجق أصابع متبل🍢",
        bbq_sausage_ingredients:
          "500 غرام هريس بطاطس متبل، 200 غرام سجق أصابع متبل، حلقات بصل، زيتون أخضر، بودرة جبنة بارميزان، طماطم كرزية، خضار صغيرة، جبنة قابلة للشوي، صلصة باربيكيو، حار",
        silo_toast: "توست سيلو",
        silo_toast_desc: "160 غرام شرايح لحم بقري رفيعة🤩",
        silo_toast_ingredients:
          "160 غرام شرايح لحم بقري رفيعة، خس فرنسي، لحم مقدد بقري، خبز ريفي، صلصة باربيكيو، صلصة تارتار، حميض، زيتون أخضر، خضار صغيرة، آيولي، بودرة جبنة بارميزان",
        salad_and_dessert: "سلطة وحلويات",
        caesar_salad: "سلطة سيزر",
        caesar_salad_desc: "سلطة سيزر لشخص واحد🥗",
        caesar_salad_ingredients:
          "مزيج خس، دجاج مشوي، جبنة بارميزان، خبز محمص (خبز بالثوم)، صلصة سيزر، زيتون",
        caesar_salad_extra: "خس روماني، خبز محمص، بارميزان",
        coleslaw_salad: "سلطة كرنب",
        coleslaw_salad_desc: "سلطة كرنب لشخص واحد🍴",
        coleslaw_salad_ingredients: "صنع يدوي، لشخص واحد، كرنب أبيض، ذرة، صلصة",
        macaroni_salad: "سلطة معكرونة",
        macaroni_salad_desc: "سلطة معكرونة وياها لحم خنزير منزلي",
        macaroni_salad_ingredients: "معكرونة، لحم خنزير منزلي",
        pachira_salad: "سلطة باتشيرا",
        pachira_salad_desc: "سلطة باتشيرا لشخصين🥗",
        pachira_salad_ingredients:
          "لشخصين، مزيج خس، رقائق لحم مقدد بقري 98%، جوز مكرمل، جبنة بارميزان، فراولة، كافيار نباتي، زبيب، شرايح ليمون، صلصة توت وردي",
        greek_salad: "سلطة يونانية",
        greek_salad_desc: "سلطة يونانية تقليدية وياها جبنة فيتا وزيتون",
        greek_salad_ingredients: "جبنة فيتا، زيتون، خيار",
        tiramisu: "تيراميسو",
        tiramisu_desc: "حلوى تيراميسو إيطالية كلاسيكية",
        tiramisu_ingredients: "قهوة، ماسكاربوني، كاكاو",
        beverages: "مشروبات",
        local_yogurt_drink: "مشروب زبادي محلي",
        local_yogurt_drink_desc: "مشروب زبادي محلي عائلي🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "مشروب غازي أسود",
        black_soda_desc: "كوب مشروب غازي أسود🧋",
        black_soda_ingredients: "",
        fanta: "مشروب غازي أصفر",
        fanta_desc: "كوب مشروب غازي أصفر🥤",
        fanta_ingredients: "",
        mojito: "موهيتو",
        mojito_desc: "كوب موهيتو، من 350 إلى 400 مل🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "مشروب شعير استوائي",
        tropical_malt_beverage_desc: "كوب مشروب شعير استوائي🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "العنوان",
        address_text: "ادخل رابط الموقع اللي تبيه",
        instagram_label: "إنستغرام",
        instagram_text: "ادخل اسم المستخدم مالك",
        whatsapp_label: "واتساب",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "معرض الفيديو",
        description:
          "عشان تعرف أكثر عن خدمات نظام كيو آر لاند الذكي، شوف الفيديوهات اللي جوه.",
        tutorial: "تعليمي",
        fast_food: "فاست فود",
      },
      feedback: {
        title: "رأيك",
        description: "جاوب على الأسئلة اللي جوه عشان نساعدك نسوي خدماتنا أحسن",
        question1: "شكد راضي عن خدماتنا وجودة الأكل؟",
        question2: "شلون تقيم تنوع الأكلات بالمطعم؟",
        question3: "شلون تقيم تصرفات موظفين المطعم؟",
        question4: "الأكل وصل بالوقت المحدد؟",
        question5: "عندك اقتراحات عشان نطور خدماتنا أو جودة الأكل؟",
      },
      worksheet: {
        saturday: "السبت",
        sunday: "الأحد",
        monday: "الإثنين",
        tuesday: "الثلاثاء",
        wednesday: "الأربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        shift_1_saturday: "من 10:00 لـ 22:00",
        shift_1_sunday: "من 10:00 لـ 22:00",
        shift_1_monday: "من 10:00 لـ 22:00",
        shift_1_tuesday: "من 10:00 لـ 22:00",
        shift_1_wednesday: "من 10:00 لـ 00:00",
        shift_1_thursday: "من 10:00 لـ 00:00",
        shift_1_friday: "من 10:00 لـ 00:00",
      },
      gallery: {
        gallery_0: "معرض 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "بطاطس مشوية 2",
        chicken_stroganoff_1: "دجاج ستروغانوف 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6، وحدة 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "إيران، طهران، مدينة طهران، طهران، المنطقة 3 بمدينة طهران، حي سيد خندان، دكتور علي شريعتي، خندان",
      },
    },
    messages: {
      qr_created_success: "القائمة أونلاين انخلقت بنجاح.",
      qr_updated_success: "كيو آر القائمة أونلاين مالك تعدّل بنجاح.",
      qr_create_error: "صار خطأ وهو يخلق الكيو آر!",
      qr_update_error: "خطأ بالحفظ/التعديل للكيو آر",
      template_categories_saved: "فئات النموذج النموذجي انحفظت بنجاح.",
      template_products_saved: "منتجات النموذج النموذجي انحفظت بنجاح.",
      template_categories_error: "خطأ بحفظ فئات النموذج النموذجي!",
      template_products_error: "خطأ بحفظ منتجات النموذج النموذجي!",
    },
    sample_menu: "قائمة نموذجية",
    view_qr: "شوف الكيو آر",
    preview: "معاينة",
    download_qr: "نزّل الكيو آر",
    create_qr: "خلّق كيو آر",
    online_menu_name: "اسم القائمة أونلاين",
    online_menu_name_short: "اسم القائمة",
    enter_qr_address: "ادخل عنوان الكيو آر",
    qr_address: "عنوان الكيو آر",
    enter_menu_information: "ادخل معلومات القائمة",
    cleardefaults: "امسح الإعدادات الافتراضية",
    select_sample_menu: "اختر قائمة نموذجية",
    select_ready_menu: "اختر قائمة جاهزة",
    online_sales: "المبيعات أونلاين",
    sales_settings: "إعدادات المبيعات",
    download: "نزّل",
    gallery_photos: "صور المعرض",
    fast_food_1: "صورة فاست فود 1",
    fast_food_2: "صورة فاست فود 2",
    large_chain_fast_food: "سلسلة فاست فود كبيرة",
    best_fast_food_taste_experience: "جرب أحسن طعم فاست فود ويانا",
    online_menu_created_successfully: "القائمة أونلاين انخلقت بنجاح.",
    qr_creation_failed: "صار خطأ وهو يخلق الكيو آر!",
    online_menu_qr_updated_successfully:
      "كيو آر القائمة أونلاين مالك تعدّل بنجاح.",
    error_saving_updating_qr: "خطأ بالحفظ/التعديل للكيو آر",
    sample_model_categories_saved_successfully:
      "فئات النموذج النموذجي انحفظت بنجاح.",
    sample_model_products_saved_successfully:
      "منتجات النموذج النموذجي انحفظت بنجاح.",
    error_saving_sample_model_products: "خطأ بحفظ منتجات النموذج النموذجي!",
    error_saving_sample_model_categories: "خطأ بحفظ فئات النموذج النموذجي!",
  },
  editMenu: {
    enter_menu_information: "ادخل معلومات القائمة",
    online_menu_name: "اسم القائمة أونلاين",
    online_menu_name_short: "اسم القائمة المختصر",
    fields: {
      qr_address_hint: "عنوان الكيو آر عشان تدخل القائمة أونلاين",
    },
    online_sales: "المبيعات أونلاين",
    sales_settings: "إعدادات المبيعات",
    shop: {
      upload_banner: "ارفع لافتة",
      create_product: "خلّق منتج",
      user_info: "معلومات المستخدم",
      add_social_media: "زيد وسائل التواصل",
      photo_gallery: "معرض الصور",
      video_gallery: "معرض الفيديو",
      feedback: "ملاحظات",
      working_hours: "ساعات العمل",
    },
    success_message: "بطاقتك الشخصية تعدّلت بنجاح.",
  },
  qrCodeSquare: {
    dots_color: "لون النقاط",
    gradient_color: "لون التدرج",
    linear: "خطي",
    radial: "دائري",
    color_rotation: "دوران اللون",
    first_color: "اللون الأول",
    second_color: "اللون الثاني",
    dots_color_label: "لون النقاط",
  },
  language: {
    selectAll: "اختر الكل",
    lang: {
      fa: "الفارسية",
      ar: "العربية",
      ar_ae: "العربية (الإمارات)",
      ar_iq: "العربية (العراق)",
      en_US: "الإنجليزية (أمريكا)",
      en_GB: "الإنجليزية (بريطانيا)",
      de: "الألمانية",
      fr: "الفرنسية",
      zh_CN: "الصينية المبسطة",
      zh_TW: "الصينية التقليدية",
      tr: "التركية",
      ru: "الروسية",
      hy: "الأرمنية",
    },
    only_manual_now: "هسة بس الترجمة اليدوية موجودة",
    ai_coming_soon: "ترجمة الذكاء الاصطناعي قريب راح تشتغل",
    got_it: "فهمت",
    origin_language: "اللغة الأصلية",
    target_languages: "اللغات المستهدفة",
    remove_all: "احذف كل اللغات",
    translation_method: "اختر طريقة الترجمة",
    manual_translation: "ترجمة يدوية",
    ai_translation: "ترجمة ذكاء اصطناعي",
    coming_soon: "قريب",
    source_language_updated: "اللغة الأصلية اتغيرت",
    error_changing_source_language: "صار خطأ بتغيير اللغة الأصلية",
    source_language_created: "لغة أصلية جديدة انخلقت",
    languages_saved: "اللغات الجديدة انحفظت",
    error_saving_languages: "صار خطأ بحفظ اللغات",
    error_loading_language: "صار خطأ بتحميل اللغة",
    languages_removed: "اللغات المحذوفة",
    new_languages_to_save: "لغات جديدة لازم تنحفظ",
    saved: "انحفظ",
    management_langs: "إدارة اللغات",
    add_langs: "أضف لغة",
    change_language: "غيّر اللغة",
    visit_card: "كارت الزيارة",
    translate_to: "ترجم لـ",
    main_language: "اللغة",
    no_languages_available: "ماكو لغات موجودة",
    return_to_default: "ارجع للغة الأصلية",
    translate: "ترجم",
    changes_pending: "بانتظار تطبيق التغييرات",
    apply_changes: "تطبيق التغييرات",
    cancel_changes: "إلغاء",
  },
  winner_list: "لستة الرابحين",
  qrwinnersList: {
    winnerstotalcount: "عدد الرابحين للكيو آر",
    winnerscountoffilter: "عدد الرابحين ويا الفلتر المطبق",
    winnersList: "لستة الرابحين بالـ QR",
    prize: "الجايزة",
    winnerName: "اسم الرابح",
    date: "التاريخ",
    noWinners: "ماكو رابحين",
    perPage: "عدد بالصفحة",
    search: "دور باسم الرابح أو الجايزة",
    sortDirection: "جهة الترتيب",
    sortBy: "ترتيب حسب",
  },
  appearance_settings: "إعدادات الشكل",
  header_color: "لون الهيدر",
  background_color: "لون الخلفية",
  text_color: "لون النص",
  font_size: "حجم الخط",
  chat_logo: "لوگو الچت",
  floating_button_icon: "أيقونة الزر الطافي",
  assistant_name: "اسم المساعد",
  chat_preview: "معاينة الچت",
  smart_assistant: "المساعد الذكي",
  online: "اونلاين",
  aiChatSettings: {
    select_assistant: "اختيار المساعد",
    appearance_settings: "إعدادات الشكل",
    lead_connection_tab: "جمع الليدات - ربط بنادي الزبائن",

    header_settings: "إعدادات الهيدر",
    header_settings_desc: "لون وستايل هيدر الچت",
    text_settings: "إعدادات النص",
    text_settings_desc: "لون الخط وحجمه",
    logo_settings: "إعدادات اللوگو",
    logo_settings_desc: "صورة أو أيقونة المساعد",
    background_settings: "إعدادات الخلفية",
    background_settings_desc: "صورة خلفية أو لون",

    gradient_color: "لون متدرج",
    solid_color: "لون واحد",
    use_image: "استخدام صورة",
    use_icon: "استخدام أيقونة",

    first_color: "اللون الأول",
    second_color: "اللون الثاني",
    header_color: "لون الهيدر",
    text_color: "لون النص",
    background_color: "لون الخلفية",

    font_size: "حجم الخط",

    robot: "روبوت",
    chat: "چت",
    support: "دعم",
    question: "سؤال",
    message: "رسالة",
    assistant_voice: "مساعد",
    ai_brain: "ذكاء اصطناعي",

    lead_connection_title: "ربط بنادي الزبائن",
    lead_alert:
      "تحديد هذه الإعدادات راح يخلي بيانات الزبون تتسجل في نادي الزبائن لمن يختار يرسل ليد.",

    hasAssistantsName_label: "استلام الاسم",
    hasAssistantsName_hint: "ناخذ اسم الزبون",
    hasAssistantsFamily_label: "استلام اسم العائلة",
    hasAssistantsFamily_hint: "ناخذ اسم العائلة مال الزبون",
    hasAssistantsMobile_label: "استلام رقم الموبايل",
    hasAssistantsMobile_hint: "ناخذ رقم الموبايل مال الزبون",
  },
  assistantChatViewer: {
    assistant_name: "المساعد الذكي",
    online: "أونلاين",
    new_chat: "چت جديد",
    clear_chat: "مسح الچت",
    close: "إغلاق",
    message_placeholder: "رسالة...",
    processing: "جاري المعالجة...",
    renew: "تجديد",
    created_at: "وقت الإنشاء",
    last_edit: "آخر تعديل",
    copied: "تم النسخ",
    copy: "نسخ",
    print_qr: "طبع الـQR",
    print_visit_card: "طبع كارت الزيارة",
    send_link: "إرسال الرابط",
    winner_list: "لستة الفايزين",
    customer_list: "لستة الزبائن",
    order_list: "لستة الطلبات",
    reserved_appointments: "المواعيد المحجوزة",
    feedback: "تعليقات",
    request_form: "فورم طلب",
    transfer_ownership: "نقل الملكية",
    store_management: "إدارة المحل",
    select_nfc_card: "اختيار كارت NFC",
    edit: "تعديل",
    design: "تصميم",
    qr_settings: "إعدادات الـQR",
    deactivate: "إيقاف",
    download: "تحميل",
    viewed: "تمت المشاهدة مرات",
    see_more: "شوف أكثر",
    updating_qr: "جاري تحديث الـQR...",
  },
  create_game: "انشاء لعبه",
  ready_games: "العاب جاهزه",
  add_game: "اضافه لعبه",
  game_gallery: "معرض العاب",
  game_size_error: "حجم ملف اللعبه ما يجوز يتجاوز 2 ميگا",
  game_upload_error: "خطا برفع اللعبه",
  no_game_available: "ماكو العاب موجوده",
  to_use_ready_games_search_category_or_product:
    "عشان تستخدم العاب جاهزه ابحث بالتصنيف او المنتج",
  gif_size_error: "حجم ملف الـGIF ما يجوز يتجاوز 2 ميگا",
  previewer_page: "عرض المعاينه",
  // ─────────────────────────────────────────────────────
  // مفاتيح الترجمة لقسم اللعبة، الـGIF والإعدادات - لهجة عراقية (محاورة بغدادية)
  // الملف: src/core/services/langs/ar_IQ.js
  // ─────────────────────────────────────────────────────
  // 1. محرر اللعبة الرئيسي (PublicGameEditor)
  game_editor: "محرر اللعبة",
  reset_defaults: "رجّع للاوليات",
  save_and_preview: "خزن وشوف قبل",
  texts: "النصوص",
  images: "الصور",
  colors: "الالوان",
  general_settings: "الاعدادات العامة",
  gameplay_settings: "اعدادات اللعب",
  effects: "التأثيرات",
  login_and_phone: "الدخول ورقم الجوال",
  no_settings_available_for_this_game_type: "ماكو اعدادات لهذا النوع من اللعبة",
  confirm_reset: "تأكد من الرجعة",
  reset_all_settings_to_default: "متأكد تريد ترجع كل الاعدادات للاول؟",
  yes_reset: "اي، رجّع",
  cancel: "الغي",
  settings_reset_successfully: "الاعدادات رجعت بنجاح",
  saved_and_ready_for_preview: "خزن وجاهز للمعاينة",

  // 2. تب الدخول ورقم الجوال (TabLogin)
  login_and_phone_settings: "اعدادات الدخول ورقم الجوال",
  ask_phone_after_game: "طلب رقم الجوال بعد اللعبة",
  phone_prompt_text: "نص طلب رقم الجوال",
  phone_prompt_hint: "النص اللي يطلع بديالوگ طلب الرقم",
  submit_button: "زر الارسال",
  login_dialog_logo: "لوگو ديالوگ الدخول",
  logo_url: "رابط اللوگو",

  // 3. تب التأثيرات (TabEffect)
  game_effects_settings: "اعدادات تأثيرات اللعبة",
  sound_enabled: "شغل الصوت",
  volume: "مستوى الصوت",
  volume_hint: "مستوى صوت اللعبة (من 0 الى 1)",
  oscillator_type: "نوع المذبذب",
  jump_sound_freq: "تردد صوت القفزة",
  hit_sound_freq: "تردد صوت التصادم",
  powerup_sound_freq: "تردد صوت الباور اب",
  move_sound_freq: "تردد صوت الحركة",
  combo_base_freq: "تردد اساس الكومبو",
  sound_durations: "مدة الاصوات",
  move_duration_ms: "مدة صوت الحركة (ملي ثانية)",
  jump_duration_ms: "مدة صوت القفزة (ملي ثانية)",
  combo_duration_ms: "مدة صوت الكومبو (ملي ثانية)",
  hit_duration_ms: "مدة صوت التصادم (ملي ثانية)",
  vibration_enabled: "شغل الاهتزاز",
  particles_enabled: "شغل الجزيئات",
  explosion_settings: "اعدادات انفجار الجزيئات",
  particle_count: "عدد الجزيئات",
  gravity: "الجاذبية",
  friction: "الاحتكاك",
  fade_speed: "سرعة التلاشي",

  // 4. تب الصور (TabImages)
  game_images_and_assets: "صور واصول اللعبة",
  player_image: "صورة اللاعب",
  player: "اللاعب",
  powerup_image: "صورة الباور اب",
  qr_powerup: "باور اب QR",
  enemy_images: "صور الاعداء",
  optional_multi: "اختياري، متعدد صور",
  enemies: "الاعداء",
  background_image: "صورة الخلفية",
  background: "الخلفية",
  phone_frame_background: "خلفية اطار الجوال",
  phone_frame: "اطار الجوال",
  winner_background: "خلفية الفائز",
  winner: "الفائز",
  ground_image: "صورة الارض",
  ground: "الارض",
  player_character: "شخصية اللاعب",
  far_background_layer: "طبقة الخلفية البعيدة",
  background_far: "خلفية بعيدة",
  near_background_layer: "طبقة الخلفية القريبة",
  background_near: "خلفية قريبة",
  obstacle_images: "صور العوائق",
  multi_optional: "متعدد صور، اختياري",
  obstacles: "العوائق",

  // 5. تب النصوص (TabTexts)
  game_text_contents: "محتوى نصوص اللعبة",
  main_screen_texts: "نصوص الشاشة الرئيسية",
  game_title: "عنوان اللعبة",
  game_subtitle: "عنوان فرعي للعبة",
  start_button: "زر البدء",
  score_label: "تسمية النقاط",
  game_over_screen: "شاشة نهاية اللعبة",
  game_over_title: "عنوان نهاية اللعبة",
  game_over_subtitle: "عنوان فرعي نهاية اللعبة",
  phone_prompt: "طلب رقم الجوال",
  restart_button: "زر اعادة البدء",
  hud_and_labels: "HUD والتسميات",
  level_label: "تسمية المرحلة",
  combo_label: "تسمية الكومبو",
  final_score_label: "تسمية النقاط النهائية",
  high_score_label: "تسمية اعلى نقاط",
  messages_and_popups: "الرسائل والنوافذ المنبثقة",
  new_record_message: "رسالة رقم قياسي جديد",
  fun_random_messages: "رسائل عشوائية ممتعة",
  add_new_message: "اضافة رسالة جديدة",

  // 6. تب الاعدادات العامة (TabSetting)
  general_game_settings: "اعدادات اللعبة العامة",
  enemy_spawn_rate: "معدل ظهور الاعداء",
  frames_between_enemies_spawn: "عدد الاطارات بين ظهور كل عدو",
  powerup_spawn_rate: "معدل ظهور الباور اب",
  frames_between_qr_spawn: "عدد الاطارات بين ظهور QR",
  win_score_threshold: "حد النقاط للفوز",
  score_required_for_win_or_phone_prompt: "النقاط المطلوبة للفوز او طلب الجوال",
  starting_lives: "عدد الحيوات الابتدائية",
  high_score_storage_key: "مفتاح حفظ اعلى نقاط",
  phone_prompt_score_threshold: "حد النقاط لطلب الجوال",
  score_to_show_phone_number_form: "النقاط لاظهار نموذج رقم الجوال",
  no_general_settings_available_for_this_game: "ماكو اعدادات عامة لهذي اللعبة",

  // 7. تب اللعب (TabGamePlay)
  speed_settings: "اعدادات السرعة",
  initial_speed: "السرعة الابتدائية",
  max_speed: "السرعة القصوى",
  speed_increase_every_frames: "زيادة السرعة كل كم اطار",
  speed_increase_amount: "كمية زيادة السرعة",
  distance_per_level: "المسافة لكل مرحلة",
  level_speed_increase: "زيادة السرعة لكل مرحلة",
  jump_and_physics: "القفز والفيزياء",
  jump_force: "قوة القفز",
  max_jump_height: "اقصى ارتفاع قفز",
  lanes_settings: "اعدادات المسارات",
  number_of_lanes: "عدد المسارات",
  starting_lane: "المسار الابتدائي",
  enemies_spawn: "ظهور الاعداء",
  traps_spawn: "ظهور الفخاخ",
  min_spawn_interval_ms: "اقل فاصل ظهور (ملي ثانية)",
  max_spawn_interval_ms: "اكبر فاصل ظهور (ملي ثانية)",
  same_lane_chance: "احتمال الظهور بنفس المسار",
  probability_of_spawn_in_player_lane: "احتمال ظهور في مسار اللاعب",
  collision_tolerance_px: "تسامح التصادم (بكسل)",
  scoring_rules: "قوانين التسجيل",
  hit_penalty: "عقوبة التصادم",
  powerup_reward: "مكافأة الباور اب",
  score_speed_divider: "مقسوم سرعة النقاط",
  reset_combo_on_hit: "رجع الكومبو عند التصادم",
  camera_settings: "اعدادات الكاميرا",
  normal_zoom: "تكبير عادي",
  hit_zoom: "تكبير عند التصادم",
  zoom_lerp_speed: "سرعة انتقال التكبير",
  game_end_conditions: "شروط نهاية اللعبة",
  phone_dialog_score_threshold: "حد النقاط لديالوگ الجوال",

  // 8. تب الالوان (TabColors)
  background_gradient: "تدرج الخلفية",
  first_color: "اللون الاول",
  second_color: "اللون الثاني",
  particle_hit_color: "لون جزيئات التصادم",
  particle_powerup_color: "لون جزيئات الباور اب",
  main_background_color: "لون الخلفية الرئيسي",
  ground_color: "لون الارض",
  hud_colors: "الوان HUD",
  hud_background: "خلفية HUD",
  score_text_color: "لون نص النقاط",
  level_text_color: "لون نص المرحلة",
  combo_text_color: "لون نص الكومبو",
  overlay_colors: "الوان الطبقة العلوية",
  backdrop_color: "لون الخلفية الخلفية",
  card_background: "خلفية الكارت",
  card_border_color: "لون حدود الكارت",
  explosion_particle_color: "لون جزيئات الانفجار",

  // 9. مكون معاينة QR (previewerQr)
  gif_tab: "تب الـGIF",
  game_tab: "تب اللعبة",
  welcome_gif_upload: "رفع GIF الترحيب",
  default_welcome: "ترحيب افتراضي",
  loading_animation: "تحميل الانميشن",
  hide_previewer: "خفي المعاينة",
  show_previewer: "اظهر المعاينة",
  edit_game_settings: "عدل اعدادات اللعبة",
  save_and_close: "خزن واغلق",
  animation_scale: "مقياس الانميشن",
  animation_slide_x: "انميشن سحب افقي",
  animation_slide_y: "انميشن سحب رأسي",
  animation_fade: "انميشن تلاشي",
  game_settings_saved: "اعدادات اللعبة خزنت",
  no_game_configured: "ماكو لعبة معدة",

  // 10. منتقي الـGIF (gifSelector)
  gallery_name: "اسم المعرض",
  change_gallery_name: "غير اسم المعرض",
  add_gif: "اضافة GIF",
  select_gif: "اختيار GIF",
  show_gif: "اظهار GIF",
  selected_gif: "GIF المختار",
  count: "العدد",
  select_category: "اختيار التصنيف",
  after_typing_enter: "بعد الكتابة اضغط انتر",
  search: "بحث",
  no_gif_available: "ماكو GIF متوفر",
  to_use_ready_gifs_search_category_or_product:
    "لاستخدام GIF جاهز ابحث بالتصنيف او المنتج",
  max_file_size_2mb: "اكبر حجم ملف 2 ميغا",
  upload_file: "رفع ملف",
  drag_and_drop_to_upload_or: "اسحب وافلت للرفع او",
  here: "هنا",
  click: "اضغط",
  all: "الكل",
  no_gif_found: "ما لكيت GIF",
  for_adding_file_use_upload_center: "لاضافة ملف استخدم مركز الرفع",
  to_use_external_gif_link_fill_fields: "لاستخدام رابط GIF خارجي املأ الحقول",
  gif_url_hint: "رابط الملف الكامل للـGIF",
  gif_url: "رابط GIF",
  add: "اضافة",
  title: "العنوان",
  link: "الرابط",
  description: "الوصف",
  add_new_gallery: "اضافة معرض جديد",
  enter_valid_link: "ادخل رابط صحيح",
  create_gif: "انشاء GIF",
  ready_gifs: "GIF جاهزة",
  gif_gallery: "معرض GIF",
  edit_gif: "تعديل GIF",
  max_background_gif_size_2mb: "اكبر حجم GIF خلفية 2 ميغا",
  uploaded_successfully: "رفع بنجاح",
  gif_upload_error: "خطأ برفع الـGIF",

  // 11. نصوص اضافية واختبارات
  preview: "معاينة",
  start_button_text: "نص زر البدء",
  game_over_text: "نص نهاية اللعبة",
  game_over_subtext: "نص فرعي نهاية اللعبة",
  mobile_prompt_text: "نص طلب الجوال",
  submit_button_text: "نص زر الارسال",
  optional: "اختياري",
  game_background: "خلفية اللعبة",
  background_gradient_colors: "الوان تدرج الخلفية",
  frames_per_enemy: "اطارات لكل عدو",
  frames_per_powerup: "اطارات لكل باور اب",
  win_threshold: "حد الفوز",
  score_to_win: "نقاط الفوز",
  your_work_page_name: "كيوار فردي/شركتي",
"pdf_gallery": {
    "display_mode": "وضع عرض معرض PDF",
    "display_mode_label": "وضع العرض",
    "layout": {
      "list": "عرض كقائمة",
      "accordion": "عرض أكورديون (قابل للطي)",
      "slider": "عرض كمزلق (سلايدر)"
    },
    "gallery_name": "اسم المعرض",
    "selected_gallery": "المعرض المحدد",
    "add_file": "إضافة ملف",
    "pdf_gallery_label": "معرض PDF",
    "select_file": "اختيار ملف",
    "title": "العنوان",
    "pdf_url": "رابط PDF",
    "description": "الوصف",
    "add_button": "إضافة",
    "all": "الكل",
    "image_gallery": "معرض الصور",
    "edit_pdf": "تعديل PDF",
    "preview": "معاينة",
    "add_pdf_gallery": "إضافة معرض PDF",
    "default_gallery_name": "معرض",
    "gallery_prefix": "معرض",
    "tabs": {
      "add_file": "إضافة ملف",
      "pdf_gallery": "معرض PDF",
      "link": "الرابط"
    },
    "messages": {
      "file_too_large": "لا يمكن أن يتجاوز حجم الملف 10 ميجابايت.",
      "invalid_file_type": "يرجى اختيار ملفات المستندات والنصوص فقط.",
      "upload_error": "خطأ في رفع الملف",
      "only_pdf_txt_allowed": "يمكن إضافة ملفات PDF و TXT فقط.",
      "title_url_required": "يرجى إدخال العنوان ورابط الملف."
    }
  },
  "special_info_desc": {
    "textCards": "إضافة بطاقات نصية لعرض معلومات المستخدم مثل الأوصاف، السيرة الذاتية، أو نبذة مختصرة.",
    "customerClubSettings": "إعداد رسالة العضوية في نادي العملاء التي يتم إرسالها للمستخدمين بعد تسجيل أرقامهم.",
    "advanceSettings": "إدارة الإعدادات المتقدمة والذكية لتخصيص سلوك وميزات الصفحة.",
    "voiceGallery": "رفع وإدارة الملفات الصوتية لتشغيلها في الصفحة.",
    "VideoGallery": "إضافة وعرض مقاطع الفيديو للتعريف، التدريب، أو عرض المحتوى.",
    "imageUploader": "رفع الصور لعرضها في المعرض أو في أجزاء مختلفة من الصفحة.",
    "colorPallete": "اختيار الألوان المفضلة لتخصيص مظهر وتصميم الصفحة.",
    "socialMediaIcons": "إضافة روابط الشبكات الاجتماعية لوصول المستخدمين السريع.",
    "pdfSelector": "رفع وعرض ملفات PDF ليقوم المستخدمون بعرضها أو تنزيلها.",
    "FeedBack": "تلقي تعليقات وملاحظات المستخدمين حول الخدمات أو المحتوى.",
    "consultationNew": "إنشاء نموذج لتقديم الطلبات، الاستشارات، أو تواصل المستخدمين."
  },
  "voice_gallery": {
    "autoplay_warning": "يمكنك ضبط ملف صوتي واحد فقط للتشغيل التلقائي في نفس الوقت.",
    "autoplay": "تشغيل تلقائي"
  },
  "card": {
    "consultation": {
      "title": "نموذج الطلب"
    },
    "form": {
      "name": "الاسم",
      "surname": "اسم العائلة",
      "phone": "رقم الجوال",
      "email": "البريد الإلكتروني",
      "address": "العنوان",
      "national_id": "رقم الهوية",
      "location": "الموقع",
      "description": "الوصف"
    },
    "feedback": {
      "title": "ملاحظاتك",
      "description": "يرجى مساعدتنا في تحسين خدماتنا من خلال الإجابة على الأسئلة التالية:",
      "q1": "ما مدى رضاك عن خدمات كيوآر لاند؟",
      "q2": "إلى أي مدى غطت خدمات كيوآر لاند احتياجاتك؟",
      "q3": "ما مدى معقولية التكلفة المدفوعة مقابل الخدمة المستلمة؟",
      "q4": "شاركنا رأيك لتحسين خدماتنا."
    },
    "pdf": {
      "gallery_name": "معرض عروض كيوآر لاند",
      "item1_title": "عرض تعريف المنتج",
      "item1_desc": "تعريف شامل بخدمات كيوآر لاند، كيفية عمل رموز الاستجابة السريعة الذكية، الفوائد للشركات وأمثلة الاستخدام لزيادة تفاعل العملاء.",
      "item2_title": "عرض بطاقة العمل الإلكترونية",
      "item2_desc": "التعريف ببطاقة العمل الرقمية من كيوآر لاند، ميزات المشاركة السريعة لمعلومات الاتصال، روابط الشبكات الاجتماعية والإدارة الاحترافية للعلاقات مع العملاء."
    },
    "pdf_selector": {
      "title": "معرض PDF",
      "description": "الوصف"
    },
    "info": {
      "visit_name": "كيوآر لاند / بطاقة العمل الإلكترونية",
      "organization_name": "كيوآر لاند",
      "sub_organ": "أول منصة لإنشاء رموز QR الديناميكية",
      "user_name": "بطاقة العمل الإلكترونية",
      "fax": "فاكس: 02191016066",
      "location_desc": "طهران، شارع شريعتي، بعد جسر سيد خندان، زقاق خندان، رقم 6",
      "postal_code": "الرمز البريدي: 1541946815",
      "about_us": "نظراً للمشاكل الموجودة في بطاقات العمل الفعلية، قدمت منصة كيوآر لاند منتجاً يسمى 'بطاقة العمل الإلكترونية'. وباستخدام التقنيات الرقمية، تمكنت من القضاء تماماً على قيود بطاقات العمل الفعلية. وفي الوقت نفسه، من خلال استبدالها بالبدائل الذكية، امنع القطع المفرط للأشجار.",
      "full_address": "إيران، طهران، مدينة طهران، المنطقة 3، حي سيد خندان، د. علي شريعتي، خندان"
    },
    "extra": {
      "field1": "🟥 أنشئ بطاقة عمل إلكترونية مشابهة لعملك الخاص.\n🟧 جربها مجاناً لمدة 3 أيام.\n🟨 انقر هنا للتسجيل مجاناً.",
      "field2": "تتميز بطاقة عملك الإلكترونية برمز QR ديناميكي. يمكنك تعديل المعلومات في أي وقت عبر هاتفك المحمول. لن يتغير رمز QR الخاص بك أبداً بعد التعديل.",
      "field3": "💲 تكلفة الحصول على هذه البطاقة هي 900 ألف تومان."
    },
    "gallery": {
      "name": "سنقف دائماً بجانبك..."
    },
    "social": {
      "address_hint": "يرجى إدخال عنوانك",
      "address_label": "العنوان",
      "instagram_hint": "يرجى إدخال رابط إنستغرام الخاص بك",
      "instagram_label": "إنستغرام",
      "whatsapp_hint": "يرجى إدخال رابط واتساب الخاص بك",
      "whatsapp_label": "واتساب"
    },
    "video": {
      "item1_name": "لماذا بطاقة كيوآر لاند؟ ما الذي يميز كيوآر لاند؟",
      "item1_title": "لماذا بطاقة عمل كيوآر لاند",
      "item2_name": "التعريف ببطاقة العمل الإلكترونية كيوآر لاند",
      "item2_title": "أفضل بديل لبطاقات العمل الفعلية"
    },
    "club": {
      "title": "عضوية نادي العملاء",
      "description": "هذا ليس نادي عملاء عادي!\nسجل رقمك"
    },
    "audio": {
      "category_all": "الكل",
      "item1_title": "الدليل الشامل لبطاقات العمل الإلكترونية",
      "diff_seconds": "قبل ثانية واحدة"
    }
  },
  "pic": {
    "background_image": "صورة الخلفية",
    "image_display_type": "نوع عرض الصورة",
    "image_orientation": "اتجاه الصورة:",
    "horizontal": "أفقي",
    "vertical": "عمودي",
    "change_display_mode": "تغيير وضع العرض",
    "image": "صورة",
    "uploaded_image": "الصورة المرفوعة"
  },
    "send_limit_per_user": "حد الإرسال لكل مستخدم (0 = بلا حدود)",
  "enable_discount_code": "تفعيل كود الخصم",
  "add_new_discount_code": "إضافة كود خصم جديد",
  "no_discount_codes_added": "ماكو أي كود خصم مضاف",
"toolsManagment": "أدوات الإدارة",
"gateway": {
  "edit": "تعديل",
  "integrated_edit_all_sections": "تعديل متكامل لجميع الأقسام",
  "show_descriptions": "عرض الأوصاف",
  "search_section_placeholder": "البحث عن قسم...",
  "no_section_found": "لم يتم العثور على قسم بهذا الاسم.",
  "back_to_menu": "العودة إلى القائمة",
  "cancel": "إلغاء",
  "save": "حفظ"
},
"gridShow": "عرض الشبكة",
"tableShow": "عرض الجدول",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "إضافة بطاقات نصية لعرض معلومات المستخدم مثل الوصف أو السجل أو نبذة مختصرة.",

    customer_club_settings_description:
      "إعداد رسالة الانضمام إلى نادي الزبائن التي تُرسل للمستخدمين بعد تسجيل رقم الهاتف.",

    advance_settings_description:
      "إدارة الإعدادات المتقدمة والذكية لتخصيص سلوك الصفحة وميزاتها.",

    voice_gallery_description:
      "رفع وإدارة الملفات الصوتية لتشغيلها في الصفحة.",

    video_gallery_description:
      "إضافة وعرض الفيديوهات للتعريف أو التدريب أو عرض المحتوى.",

    image_uploader_description:
      "رفع الصور لعرضها في المعرض أو في أقسام مختلفة من الصفحة.",

    color_palette_description:
      "اختيار الألوان المفضلة لتخصيص مظهر وتصميم الصفحة.",

    social_media_icons_description:
      "إضافة روابط مواقع التواصل الاجتماعي للوصول السريع إليها.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "رفع أو تغيير صورة البانر الرئيسية للمجمع.",

    logo_select_description:
      "تعيين شعار النشاط التجاري أو المجمع.",

    service_description:
      "إدارة الخدمات والمرافق الرئيسية للمجمع.",

    faq_description:
      "إضافة وتعديل الأسئلة الشائعة للزبائن.",

    blog_description:
      "إضافة المقالات والأخبار المتعلقة بالمجمع.",

    floor_description:
      "إدارة الطوابق والوحدات التجارية في المجمع.",

    text_cards_description:
      "إدخال الوصف والمعلومات المتعلقة بالمستخدم.",

    social_media_icons_description:
      "إضافة روابط مواقع التواصل الاجتماعي للتواصل مع الزبائن.",

    pic_selector_description:
      "إضافة صور المجمع والمتاجر.",

    video_gallery_description:
      "رفع الفيديوهات التعريفية أو الإعلانية.",

    pdf_selector_description:
      "إدارة الكتالوجات والملفات الإرشادية.",

    feedback_description:
      "إدارة قسم آراء وملاحظات الزوار.",

    consultation_new_description:
      "إدارة نموذج جمع معلومات الزبائن أو طلباتهم.",

    service_section_description:
      "إنشاء أقسام مخصصة للخدمات.",

    counter_service_description:
      "عرض إحصائيات وإنجازات المجمع بشكل رقمي.",

    counter_description:
      "إعداد العد التنازلي للفعاليات أو الافتتاح.",

    personnel_description:
      "التعريف بالمديرين وأعضاء الفريق الرئيسيين.",

    customer_club_settings_description:
      "إدارة إعدادات الرسائل النصية والتسجيل في نادي الزبائن.",

    work_sheet_description:
      "تحديد ساعات العمل وأيام نشاط المجمع.",

    pallet_commercial_description:
      "إعداد ألوان ونمط المظهر العام للصفحة.",

    default_description:
      "إضافة وإدارة قسم {title} في صفحة العمل.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "إعدادات صفحة تسجيل الدخول وتغيير شعار المتجر.",

  banner_selector_description:
    "رفع وإدارة بانرات المتجر.",

  text_cards_description:
    "المعلومات النصية والتعريفية ونبذة عن المتجر.",

  product_description:
    "إنشاء المنتجات وإدارتها وتعديلها.",

  special_category_manager_description:
    "إدارة فئات العروض الخاصة والمنتجات المخفضة.",

  social_media_icons_description:
    "إضافة روابط مواقع التواصل الاجتماعي للمتجر.",

  blog_description:
    "كتابة وإدارة منشورات المدونة.",

  service_description:
    "التعريف بالخدمات الإضافية المقدمة.",

  faq_description:
    "عرض وإدارة قائمة الأسئلة الشائعة للمستخدمين.",

  pic_selector_description:
    "رفع وإدارة معرض صور المتجر.",

  video_gallery_description:
    "رفع الفيديوهات التعريفية والإعلانية.",

  pdf_selector_description:
    "توفير الملفات الإرشادية أو كتالوجات PDF.",

  feedback_description:
    "إدارة قسم آراء وملاحظات الزبائن.",

  counter_description:
    "إعداد العد التنازلي للفعاليات أو العروض.",

  consultation_description:
    "إنشاء نموذج لاستقبال الطلبات أو طلب الاستشارة.",

  service_section_description:
    "إدارة الأقسام المخصصة للخدمات.",

  counter_service_description:
    "عرض الإحصائيات والأرقام وإنجازات المتجر.",

  personnel_description:
    "التعريف بأعضاء الفريق وموظفي المتجر.",

  work_sheet_description:
    "إعداد أيام وساعات عمل المتجر.",

  default_description:
    "إضافة وإدارة قسم {title} في صفحة المتجر.",
},
edit_gold_special_info_single: {
  product_info_title: "معلومات المنتج",
  product_info_description:
    "تسجيل وتعديل المعلومات الأساسية للمنتج والميزات والسعر والوصف الإضافي.",

  asset_management_title: "إدارة الأصول",
  asset_management_description:
    "إدارة الأصول وتخصيص القيمة ومعلومات المحفظة المرتبطة بالمنتج.",

  add_social_networks_title: "إضافة شبكات التواصل الاجتماعي",
  social_networks_title: "شبكات التواصل الاجتماعي",
  social_media_description:
    "إضافة روابط شبكات التواصل الاجتماعي لتسهيل تواصل الزبائن مع علامتك التجارية.",

  add_video_title: "إضافة فيديو",
  video_description:
    "إضافة وعرض فيديوهات تعريفية أو تعليمية أو إعلانية للمنتج.",

  add_image_title: "إضافة صورة",
  image_description:
    "رفع صور عالية الجودة للمنتج من زوايا مختلفة لعرضه بشكل أفضل في المعرض.",

  select_color_title: "اختيار اللون",
  color_palette_description:
    "تخصيص ألوان ومظهر صفحة عرض المنتج بما يتناسب مع هوية علامتك التجارية.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "تعديل الاسم وصورة الملف الشخصي والخلفية",

  management_account_description:
    "إضافة وتعديل معلومات الحسابات المصرفية",

  management_color_description:
    "تغيير ألوان أزرار الواجهة والخلفية",
},

edit_feedback_special_single: {
  base_info_description:
    "تعديل المعلومات الأساسية وعنوان النموذج",

  image_uploader_description:
    "رفع وإدارة شعار نموذج الملاحظات",

  feedback_description:
    "إعدادات الحقول وإدارة نموذج استقبال الملاحظات",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص مظهر النموذج",
},

edit_gitf_special_info_single: {
  default_description:
    "إضافة وإدارة قسم {title} في رمز QR لإطار الذكريات.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "المعلومات الأساسية والعنوان ووصف الكتالوج",

  image_uploader_description:
    "رفع وإدارة الشعار أو الصورة الرئيسية",

  pic_selector_description:
    "رفع وإدارة صفحات الكتالوج أو الكتيب",

  social_media_icons_description:
    "إضافة وإدارة روابط شبكات التواصل الاجتماعي",

  color_palette_description:
    "اختيار نظام الألوان وتخصيص المظهر",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "اختيار قالب لتطبيق تصنيف مختلف",

  login_config_description:
    "إعدادات ومظهر صفحة تسجيل الدخول",

  general_settings_description:
    "الإعدادات العامة للعملة ونوع نشاطك التجاري.",

  banner_selector_description:
    "رفع واختيار صورة بانر لعرضها أعلى الصفحة وجعل مظهر القائمة أو الملف الشخصي أكثر جاذبية.",

  product_description:
    "إنشاء وإدارة المنتجات أو الخدمات مع تفاصيل مثل الصورة والسعر والوصف المخصص.",

  text_cards_description:
    "إضافة بطاقات نصية لعرض معلومات المستخدم الأساسية مثل الوصف العام أو الخبرات أو نبذة قصيرة.",

  social_media_description:
    "إضافة روابط وأيقونات شبكات التواصل الاجتماعي لتسهيل التواصل والوصول للعملاء.",

  photo_gallery_description:
    "إنشاء معرض صور لعرض صور المنتجات أو نماذج الأعمال أو بيئة النشاط التجاري.",

  video_gallery_description:
    "إضافة معرض فيديو لعرض الإعلانات الترويجية أو الفيديوهات التعليمية أو التعريفية.",

  feedback_description:
    "إنشاء قسم لعرض آراء الزبائن وملاحظاتهم ومستوى رضا الزبائن السابقين.",

  working_hours_description:
    "تحديد ساعات العمل وأوقات نشاط النشاط التجاري.",
},

edit_pdf_special_info_single: {
  base_info_title: "المعلومات",
  base_info_description:
    "إضافة بطاقات نصية لعرض المعلومات الأساسية للمستخدم مثل الوصف العام أو الخبرات أو نبذة قصيرة.",

  image_uploader_title: "رفع الشعار",
  image_uploader_description:
    "رفع واختيار صورة لاستخدامها كشعار أو صورة ملف شخصي لعرضها على الصفحة.",

  pdf_selector_title: "إضافة معرض PDF",
  pdf_selector_description:
    "إنشاء معرض لملفات PDF أو الملفات النصية مع إمكانية إضافة صورة غلاف ووصف مخصص لكل ملف.",

  social_media_icons_title: "إضافة شبكات التواصل الاجتماعي",
  social_media_icons_description:
    "إضافة روابط وأيقونات شبكات التواصل الاجتماعي لتسهيل التواصل والوصول.",

  color_palette_title: "اختيار اللون",
  color_palette_description:
    "اختيار لون القالب وتخصيص المظهر العام للعناصر ليتناسب بشكل أفضل مع علامتك التجارية.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "إضافة وإدارة قسم {title} في معرض الصور.",
},

edi_social_special_info_single: {
  banner_selector_title: "رفع الصورة",
  banner_selector_description:
    "اختيار ورفع صورة الخلفية أو البانر أعلى صفحة شبكات التواصل الاجتماعي الخاصة بك.",

  base_info_title: "المعلومات",
  base_info_description:
    "أدخل المعلومات الأساسية مثل العنوان الرئيسي ووصف ملفك الشخصي.",

  image_uploader_title: "رفع الشعار",
  image_uploader_description:
    "ارفع شعارك أو صورة ملفك الشخصي أو صورة علامتك التجارية لعرضها على الصفحة.",

  social_media_icons_title: "إضافة شبكات التواصل الاجتماعي",
  social_media_icons_description:
    "أضف روابط شبكات التواصل الاجتماعي مثل إنستغرام وتلغرام وواتساب ولينكدإن وغيرها لعرض أيقوناتها على الصفحة.",
},

edit_text_special_info_single: {
  base_info_title: "معلومات ونصوص QR",
  base_info_subtitle: "النص الرئيسي والحقول النصية",
  base_info_description:
    "تعديل العنوان والنص الرئيسي حولنا والحقول النصية المخصصة لـ QR",

  image_uploader_title: "الشعار وصورة الخلفية",
  image_uploader_subtitle: "إعدادات الصورة",
  image_uploader_description:
    "رفع وتغيير الشعار المخصص أو صورة خلفية البطاقة",

  color_palette_subtitle: "تخصيص المظهر",
  color_palette_description:
    "ضبط لون الرأس والخلفية وألوان النصوص لتحسين سهولة القراءة والتباين",
},

edit_video_special_info_single: {
  base_info_title: "المعلومات",
  base_info_description:
    "تعديل المعلومات الأساسية مثل العنوان وعنوان رمز QR.",

  image_uploader_title: "رفع الشعار",
  image_uploader_description:
    "رفع وإدارة صورة شعار الصفحة.",

  video_gallery_title: "معرض الفيديو",
  video_gallery_description:
    "إضافة وتعديل وإدارة مقاطع الفيديو لعرضها في المعرض.",

  social_media_icons_title: "إضافة شبكات التواصل الاجتماعي",
  social_media_icons_description:
    "إضافة روابط شبكات التواصل الاجتماعي ووسائل الاتصال.",

  color_palette_title: "اختيار اللون",
  color_palette_description:
    "تغيير الألوان واختيار نظام ألوان مناسب للصفحة.",
},

edit_product_special_info_single: {
  factory_info_description: "تعديل معلومات وتعريف المجموعة",
  single_product_editor_description:
    "تعديل المعلومات الأساسية وأزرار الدعوة إلى الإجراء مثل الشراء",
  customer_club_settings_description:
    "إعدادات نادي العملاء وإرسال الرسائل النصية",
  advance_settings_description:
    "إعدادات العرض والأمان المتقدمة",
  features_description:
    "إدارة ميزات المنتج ومواصفاته الفنية",
  voice_gallery_description:
    "رفع وإدارة البودكاست والملفات الصوتية",
  image_uploader_description:
    "رفع وإدارة معرض صور المنتج",
  video_gallery_description:
    "إضافة وإدارة معرض الفيديوهات المرتبطة",
  social_media_icons_description:
    "إضافة وإدارة روابط شبكات التواصل الاجتماعي",
  color_palette_description:
    "اختيار نظام الألوان وتخصيص القالب",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "أدخل المعلومات العامة والتعريف بالمجموعة الإنتاجية.",
  single_product_editor_description:
    "اضبط المعلومات الأساسية وشارة الثقة وزر شراء المنتج.",
  customer_club_settings_description:
    "إعدادات الرسائل النصية وانضمام العملاء إلى النادي.",
  features_description:
    "أضف ميزات المنتج ومواصفاته الفنية.",
  feedback_description:
    "قسم آراء وملاحظات المشترين.",
  consultation_description:
    "نموذج طلب استشارة أو تسجيل طلب.",
  advance_settings_description:
    "إعدادات متقدمة وذكية لعرض المنتج.",
  voice_gallery_description:
    "ملفات صوتية للتعريف بالمنتج أو إرشادات استخدامه.",
  image_uploader_description:
    "ارفع صور المنتج المختلفة.",
  video_gallery_description:
    "فيديوهات تعريفية أو تعليمية مرتبطة بالمنتج.",
  social_media_icons_description:
    "روابط شبكات التواصل الاجتماعي لمزيد من التواصل.",
  color_palette_description:
    "اضبط ألوان وأسلوب المظهر العام لصفحة المنتج.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "المعلومات الأساسية ومواصفات معرض الصوت",
  image_uploader_description:
    "رفع وإدارة الشعار أو صورة الغلاف",
  voice_gallery_description:
    "رفع وإدارة الملفات الصوتية والبودكاست",
  color_palette_description:
    "اختيار نظام الألوان وتخصيص مظهر المعرض",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "تعديل عنوان ووصف المعرض",
  image_uploader_description:
    "رفع وإدارة الشعار والغلاف الرئيسي",
  voice_gallery_acc_description:
    "رفع وحذف وإدارة الملفات الصوتية",
  social_media_icons_description:
    "إضافة وإدارة روابط شبكات التواصل الاجتماعي",
  color_palette_description:
    "اختيار نظام الألوان وتخصيص مظهر المعرض",
},
edit_bpage_special_info_special: {
  advertising_sites: "مواقع الإعلانات",
stores: "المتاجر",

divar: "دیوار",
divar_hint: "أدخل رابط دیوار",

sheypoor: "شیپور",
sheypoor_hint: "أدخل رابط شیپور",

digikala: "دیجی‌کالا",
digikala_hint: "أدخل رابط دیجی‌کالا",

basalam: "باسلام",
basalam_hint: "أدخل رابط باسلام",

snappshop: "سناب شوب",
snappshop_hint: "أدخل رابط سناب شوب",

technolife: "تكنولايف",
technolife_hint: "أدخل رابط تكنولايف",

torob: "تروب",
torob_hint: "أدخل رابط تروب",

emalls: "إيمالز",
emalls_hint: "أدخل رابط إيمالز",

cafebazaar: "كافه بازار",
cafebazaar_hint: "أدخل رابط كافه بازار",

googleplay: "جوجل بلاي",
googleplay_hint: "أدخل رابط جوجل بلاي",

samsung: "سامسونج",
samsung_hint: "أدخل رابط متجر Galaxy",

apple: "آبل",
apple_hint: "أدخل رابط متجر App Store",
  add_audio_gallery: "إضافة معرض الملفات الصوتية",
  factory_information: "معلومات المؤسسة",
  trust_badge: "شارة الثقة",
  buy_button: "زر الشراء",
  smart_settings: "الإعدادات الذكية",
  add_product_feature: "إضافة خاصية للمنتج",
  product_features: "خصائص المنتج",
  add_audio_file: "إضافة ملف صوتي",
  audio_gallery: "معرض الصوتيات",
  text: "النص",
  logo_background: "الشعار / الخلفية",
  select_color: "اختيار اللون",
  information: "المعلومات",
  luck_management: "إدارة الحظ",
  registration_management: "إدارة التسجيل",
  turning: "التقليب",
  slider: "السلايدر",
  vertical: "عمودي",
  upload_catalog_brochure_images: "رفع صور الكتالوج / البروشور",
  upload_banner: "رفع البانر",
  upload_header_image: "رفع صورة الهيدر",
  upload_image: "رفع صورة",
  services: "الخدمات",
  faq: "الأسئلة الشائعة",
  blog: "المدونة",
  create_product: "إنشاء منتج",
  user_information: "معلومات المستخدم",
  add_social_media: "إضافة شبكات التواصل الاجتماعي",
  photo_gallery: "معرض الصور",
  video_gallery: "معرض الفيديو",
  pdf_gallery: "معرض ملفات PDF",
  feedback: "الملاحظات",
  request_form: "نموذج الطلب",
  create_section: "إنشاء قسم",
  achievements: "الإنجازات",
  countdown: "العد التنازلي",
  team_members: "أعضاء الفريق",
  working_hours: "ساعات العمل",
  upload_logo: "رفع الشعار",
  create_store: "إنشاء متجر",
  customer_club_membership_sms: "رسالة الانضمام إلى نادي الزبائن",
  product_information: "معلومات المنتج",
  asset_management: "إدارة الأصول",
  social_media: "شبكات التواصل الاجتماعي",
  add_video: "إضافة فيديو",
  add_image: "إضافة صورة",
  add_user_information: "إضافة معلومات المستخدم",
  manage_accounts: "إدارة الحسابات",
  manage_color: "إدارة الألوان",
  download_qr: "تنزيل رمز QR",
  add_store: "إضافة متجر",
  manage_appointments: "إدارة المواعيد",
},
edit_gift_special_info_special: {
  gift_story: "قصة الهدية",
  profile_image: "صورة الملف الشخصي",
  featured_images: "الصور المميزة",
  image_gallery: "معرض الصور",
  video_gallery: "معرض الفيديو",
  add_audio_file: "إضافة ملف صوتي",
  select_color: "اختيار اللون",
},
edit_insurance_special_info_special: {
  login_settings: "إعدادات تسجيل الدخول",
  shop_logo_images: "شعار وصور المتجر",
  login_page_information: "معلومات صفحة تسجيل الدخول",
  upload_banner_logo: "رفع البانر والشعار",
  user_information: "معلومات المستخدم",
  manage_products_insurance: "إدارة المنتجات / التأمينات",
  special_sale: "العروض الخاصة",
  add_social_media: "إضافة شبكات التواصل الاجتماعي",
  blog: "المدونة",
  services: "الخدمات",
  faq: "الأسئلة الشائعة",
  photo_gallery: "معرض الصور",
  video_gallery: "معرض الفيديو",
  pdf_gallery: "معرض ملفات PDF",
  feedback: "التعليقات",
  countdown: "العد التنازلي",
  request_form: "نموذج الطلب",
  create_section: "إنشاء قسم",
  achievements: "الإنجازات",
  team_members: "أعضاء الفريق",
  working_hours: "ساعات العمل",
  shop_login_description: "إعدادات شعار وصفحة تسجيل دخول المتجر",
  insurance_manage_description: "إضافة وتعديل قائمة المنتجات / الخدمات",
  banner_description: "إدارة صور الرأس",
},
};
